import React, { Component } from 'react';
import { connect } from "react-redux";
import Wrapper from "../../../helpers/wrapper";
import Col from "react-bootstrap/esm/Col";
import { Link } from 'react-router-dom'
import { Dropdown } from "../../../shared/components/dropdown/dropdown"
import RISummaryPageHeader from '../../../layout/ri-pageheader/ri-summarypageheader';
import SolidGaugeChart from '../../../shared/components/charts/SolidGaugeChart';
import Linegraph_sparkline from '../../../shared/components/charts/Linegraph_sparkline';
import RiSalesVBarChart from '../../../shared/components/charts/RiSalesVBarChart';
import RiStoreBubbleChart from '../../../shared/components/charts/RiStoreBubbleChart1';
import RiSalesPieChart from '../../../shared/components/charts/RiSalesPieChart';
import RiTreegraph from '../../../shared/components/charts/RiTreegraph1';
import StackedColumnChart from '../../../shared/components/charts/StackedColumnChart';
import IconSmiley from '../../../../assets/images/icons/smileyIcon';
import IconDownload from '../../../../assets/images/icons/downloadIcon'
import IconUserGroup from "../../../../assets/images/icons/usergroupIcon";
import IconStore from '../../../../assets/images/icons/storeIcon';
import IconTag from '../../../../assets/images/icons/tagIcon';
import { Tab } from "../../../shared/components/tabs/tab";
import { TabNav } from "../../../shared/components/tabs/tabnav";
import RiTopMoversTab from '../../ri/ri-storehealth/RiTopMoversTab'
import Progressbar from '../../../shared/components/progressbar/progressbar'
import { ChartCard } from '../../../shared/components/cards/chartcard/chartcard'
import { SummaryCard } from '../../../shared/components/cards/risummarycard/summarycard'
import { ScoreCard } from '../../../shared/components/cards/riscorecard/riscorecard';
import { Carousel } from '../../../shared/components/carousel/carousel';
import IconWebsite from '../../../../assets/images/icons/websiteIcon';
import { StoreCategory } from './RiStoreCategory';
import { StoreCustomer } from './RiStoreCustomer';
import { StorePresence } from './RiStorePresence';
import { StoreSale } from './RiStoreSale';
import IconPdf from '../../../../assets/images/icons/pdfIcon';
import DatePicker from '../../../shared/components/datepicker/datepicker';
import { Breadcrumb, Container, Image, ProgressBar } from 'react-bootstrap';
import RiMapFilter from '../ri-mapfilter/RiMapFilter';
import IndiaMap from '../../../shared/components/map/indiamap/indiamap';
import { Loader } from '../../../shared/components/loader/loader';

import StickyLogo from '../../../../assets/images/icons/icon.png'
import ChartExport from "../../../shared/components/export/ChartExport";
import UKMap from "../../../shared/components/map/ukmap/ukmap";

import BRAND1 from "../../../../assets/images/brands/brand1.png";
import BRAND2 from "../../../../assets/images/brands/brand2.png";
import BRAND3 from "../../../../assets/images/brands/brand3.png";
import BRAND4 from "../../../../assets/images/brands/brand4.png";
import BRAND5 from "../../../../assets/images/brands/brand5.png";
import BrandDropdown from "../../../shared/components/dropdown/brandDropdown";
import PageHeader from '../../../../../components/layout/pageHeader';
import USMap from '../../../shared/components/map/usmap/usmap';
import { API_URL } from '../../../../../constants/constants';



export class StoreHealthOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubNav: 'Revenue', // Set Revenue as the default active tab
      brandsDropdownOptions: [
        {
          value: "pulsar",
          label: "Pulsar",
          icon: (
            <img
              src={BRAND1}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        },
        {
          value: "platina",
          label: "Platina",
          icon: (
            <img
              src={BRAND2}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        },
        {
          value: "ct",
          label: "CT",
          icon: (
            <img
              src={BRAND3}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        },
        {
          value: "avenger",
          label: "Avenger",
          icon: (
            <img
              src={BRAND4}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        },
        {
          value: "dominar",
          label: "Dominar",
          icon: (
            <img
              src={BRAND5}
              style={{ width: "25px", height: "25px", borderRadius: "100%" }}
            />
          ),
        }
      ],

      selectedBrandDropdownOption: "",

      footfalls_dropdown_options: [{ "value": "footfalls", "label": "New customer" }, { "value": "nsv", "label": "Fixed Deposit" },],
      nsv_dropdown_options: [{ "value": "footfalls", "label": "New customer" }, { "value": "nsv", "label": "Fixed Deposit" },],
      footfalls_dropdown_value: "footfalls",
      nsv_dropdown_value: "nsv",
      category_dropdown_options: [{ "value": "nsv", "label": "NSV" }, { "value": "sell_through", "label": "Sell Thru" }],
      category_dropdown_value: "nsv",
      custprofiling_dropdown_options: [{ "value": "promoshoppers", "label": "Promo Shoppers" }, { "value": "mtoshoppers", "label": "MTO Shoppers" }, { "value": "nonshoppers", "label": "Non Shoppers" }, { "value": "highvalueshoppers", "label": "High Value Shoppers" }, { "value": "lowvalueshoppers", "label": "Low Value Shoppers" }],
      // business: [{ "category": "Overall", "value": 80, "full": 100 }, { "category": "Zone", "value": 35, "full": 100 }, { "category": "City", "value": 92, "full": 100 }, { "category": "Store", "value": 68, "full": 100 }],
      // sale: [{ "category": "Overall", "value": 80, "full": 100 }, { "category": "Zone", "value": 35, "full": 100 }, { "category": "City", "value": 92, "full": 100 }, { "category": "Store", "value": 68, "full": 100 }],
      // customer: [{ "category": "Overall", "value": 80, "full": 100 }, { "category": "Zone", "value": 35, "full": 100 }, { "category": "City", "value": 92, "full": 100 }, { "category": "Store", "value": 68, "full": 100 }],
      // product: [{ "category": "Overall", "value": 80, "full": 100 }, { "category": "Zone", "value": 35, "full": 100 }, { "category": "City", "value": 92, "full": 100 }, { "category": "Store", "value": 68, "full": 100 }],
      // category: [{ "category": "Overall", "value": 80, "full": 100 }, { "category": "Zone", "value": 35, "full": 100 }, { "category": "City", "value": 92, "full": 100 }, { "category": "Store", "value": 68, "full": 100 }],
      gaugedata: [{ "hand1.value": "50" }, { "hand2.value": "80" }, { "hand3.value": "40" }, { "hand4.value": "15" }],
      linesparkgraph: [{ "date": "2012-07-27", "value": 13 }, { "date": "2012-07-28", "value": 10 }, { "date": "2012-07-29", "value": 15 }, { "date": "2012-07-30", "value": 15 }, { "date": "2012-07-31", "value": 15 }, { "date": "2012-08-01", "value": 15 }, { "date": "2012-08-02", "value": 15 }, { "date": "2012-08-03", "value": 19 }, { "date": "2012-08-04", "value": 16 }, { "date": "2012-08-05", "value": 15 }, { "date": "2012-08-06", "value": 19 }, { "date": "2012-08-07", "value": 17 }, { "date": "2012-08-08", "value": 18 }],
      // topstoredata: [{ "category": "0123", "value": "98" }, { "category": "0124", "value": "97" }, { "category": "0185", "value": "96" }, { "category": "9653", "value": "95" }, { "category": "7456", "value": "93" }, { "category": "7423", "value": "87" }, { "category": "1523", "value": "80" }, { "category": "5689", "value": "77" }, { "category": "9862", "value": "72" }, { "category": "7485", "value": "68" }],
      // bottomstoredata: [{ "category": "8465", "value": "35" }, { "category": "9865", "value": "38" }, { "category": "7856", "value": "39" }, { "category": "9653", "value": "44" }, { "category": "7456", "value": "49" }, { "category": "7423", "value": "55" }, { "category": "1523", "value": "59" }, { "category": "5689", "value": "60" }, { "category": "9862", "value": "63" }, { "category": "7485", "value": "68" }],
      topstoredata: '',
      bottomstoredata: '',
      //storedata: '[{"name":"Store1","y":470,"x":10,"value":20,"y2":550,"x2":18,"value2":20,"y3":1350,"x3":8,"value3":24},{"name":"Store2","y":675,"x":20,"value":20,"y2":810,"x2":14,"value2":23,"y3":320,"x3":23,"value3":20},{"name":"Store3","y":590,"x":28,"value":20,"y2":1800,"x2":35,"value2":25,"y3":960,"x3":41,"value3":22},{"name":"Store4","y":676,"x":51,"value":25,"y2":245,"x2":76,"value2":28,"y3":654,"x3":88,"value3":24},{"name":"Store5","y":2305,"x":86,"value":22,"y2":710,"x2":92,"value2":22,"y3":676,"x3":93,"value3":24},{"name":"Store6","y":853,"x":99,"value":22,"y2":702,"x2":75,"value2":21,"y3":564,"x3":60,"value3":24},{"name":"Store7","y":3001,"x":36,"value":20,"y2":1725,"x2":43,"value2":24,"y3":644,"x3":76,"value3":20}]',
      storedata: [{ "name": "BF-APTL-HYD-ABIDS", "y": 5634, "x": 6143091.96, "value": "0.56", "color": "#d51f30" }, { "name": "BF-APTL-HYD-ATTAPUR", "y": 2114, "x": 2235100.96, "value": "0.20", "color": "#d51f30" }, { "name": "BF-APTL-HYD-BEGUMPETH", "y": 1846, "x": 1699692.03, "value": "0.15", "color": "#d51f30" }, { "name": "BF-APTL-HYD-JUBILEE HILLS", "y": 1426, "x": 1158691.01, "value": "0.10", "color": "#d51f30" }, { "name": "BF-APTL-HYD-KUKATPALLY", "y": 1952, "x": 3181224.01, "value": "0.29", "color": "#d51f30" }, { "name": "BF-APTL-HYD-MIYAPUR-RAMACHAND", "y": 2271, "x": 2345052.96, "value": "0.21", "color": "#d51f30" }, { "name": "BF-APTL-HYD-TOLICHOWKI", "y": 1838, "x": 1724075.01, "value": "0.16", "color": "#d51f30" }, { "name": "BF-APTL-SECBAD-KARKHANA", "y": 1244, "x": 1061489, "value": "0.10", "color": "#d51f30" }, { "name": "BF-APTL-VIJAYWADA-BENZ CIRCLE", "y": 1937, "x": 2202379, "value": "0.20", "color": "#d51f30" }, { "name": "BF-APTL-VISAKHAPATNAM-SRIRAMA NARAS", "y": 1916, "x": 1800401.01, "value": "0.16", "color": "#d51f30" }, { "name": "BF-EAST-ASANSOL-SENTRUM MALL", "y": 2498, "x": 1721168.02, "value": "0.16", "color": "#db7823" }, { "name": "BF-EAST-BHUBANESWAR-SHAHEEDNAGAR", "y": 2878, "x": 3819111.04, "value": "0.35", "color": "#d51f30" }, { "name": "BF-EAST-GUWAHATI-PRITHVI PLANET", "y": 2002, "x": 2782682.01, "value": "0.25", "color": "#d51f30" }, { "name": "BF-EAST-KOL-AJC BOSE ROAD", "y": 852, "x": 1709668.02, "value": "0.15", "color": "#d51f30" }, { "name": "BF-EAST-KOL-BEHALA", "y": 2155, "x": 2128561.96, "value": "0.19", "color": "#d51f30" }, { "name": "BF-EAST-KOL-BT ROAD", "y": 1446, "x": 1684837.03, "value": "0.15", "color": "#d51f30" }, { "name": "BF-EAST-KOL-CHINAR PARK", "y": 2636, "x": 2996967.98, "value": "0.27", "color": "#d51f30" }, { "name": "BF-EAST-KOL-DUM DUM ROAD", "y": 1133, "x": 2012985.98, "value": "0.18", "color": "#db7823" }, { "name": "BF-EAST-KOL-LEE ROAD", "y": 3787, "x": 4204267.93, "value": "0.38", "color": "#d51f30" }, { "name": "BF-EAST-KOL-SALT LAKE STADIUM", "y": 2527, "x": 2871072.98, "value": "0.26", "color": "#d51f30" }, { "name": "BF-EAST-KOL-SUGAM SUDHIR", "y": 1977, "x": 2064945.97, "value": "0.19", "color": "#d51f30" }, { "name": "BF-EAST-PATNA-GODAVARI PALACE", "y": 1529, "x": 1941263.01, "value": "0.18", "color": "#d51f30" }, { "name": "BF-EAST-PATNA-RAJA BAZAAR", "y": 3201, "x": 3389054.04, "value": "0.31", "color": "#d51f30" }, { "name": "BF-EAST-RAIPUR-PANCHPEDI NAKA", "y": 1471, "x": 1959365.01, "value": "0.18", "color": "#d51f30" }, { "name": "BF-NORTH-AGRA-RATAN MALL", "y": 1889, "x": 1930336.01, "value": "0.17", "color": "#db7823" }, { "name": "BF-NORTH-ALLAHABAD", "y": 1886, "x": 1966038.01, "value": "0.18", "color": "#d51f30" }, { "name": "BF-NORTH-AMRITSAR-CELEBRATION MALL", "y": 1594, "x": 1732138.99, "value": "0.16", "color": "#d51f30" }, { "name": "BF-NORTH-DELHI-CITY SQUARE MALL", "y": 1453, "x": 2139366.01, "value": "0.19", "color": "#d51f30" }, { "name": "BF-NORTH-GHAZIABAD-JAIPURIA SUNRISE", "y": 1687, "x": 2211769.02, "value": "0.20", "color": "#d51f30" }, { "name": "BF-NORTH-GHAZIABAD-PACIFIC MALL", "y": 1707, "x": 2818916.98, "value": "0.25", "color": "#db7823" }, { "name": "BF-NORTH-JAIPUR-SUNNY TRADE CENTER", "y": 2263, "x": 3576878.07, "value": "0.32", "color": "#db7823" }, { "name": "BF-NORTH-JAMMU-PRITHVI PLANET", "y": 1166, "x": 1507250.98, "value": "0.14", "color": "#db7823" }, { "name": "BF-NORTH-KANPUR-RAVE MOTI MALL", "y": 2063, "x": 2316405.01, "value": "0.21", "color": "#db7823" }, { "name": "BF-NORTH-LUCKNOW-SKY LAP", "y": 2336, "x": 2573651.03, "value": "0.23", "color": "#d51f30" }, { "name": "BF-NORTH-ZIRAKHPUR-COSMOS PLAZA MALL", "y": 3604, "x": 2776416.04, "value": "0.25", "color": "#db7823" }, { "name": "BF-SOUTH-BGLR-ARCH MALL", "y": 824, "x": 874653.01, "value": "0.08", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-BANNERGHATTA", "y": 1476, "x": 1601399.98, "value": "0.14", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-BANSHANKARI", "y": 1076, "x": 1662174.96, "value": "0.15", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-ELECTRONIC CITY", "y": 929, "x": 1265153.97, "value": "0.11", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-HOMBEGOWDA NAGAR", "y": 2232, "x": 2943544.05, "value": "0.27", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-HOSUR ROAD", "y": 1312, "x": 1171274, "value": "0.11", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-KANAKPURA ROAD", "y": 1434, "x": 1788660.99, "value": "0.16", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-MALLESHWARAM", "y": 2304, "x": 3375794.94, "value": "0.31", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-MARATHAHALLI 2.0", "y": 4673, "x": 3796614.03, "value": "0.34", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-ROCKLINE MALL", "y": 947, "x": 1140500.98, "value": "0.10", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-SARJAPUR ROAD", "y": 816, "x": 975319, "value": "0.09", "color": "#d51f30" }, { "name": "BF-SOUTH-BGLR-WHITE FIELD", "y": 980, "x": 1268035.03, "value": "0.11", "color": "#d51f30" }, { "name": "BF-SOUTH-CALICUT-ACE CENTRE POINT", "y": 1770, "x": 1435662.02, "value": "0.13", "color": "#d51f30" }, { "name": "BF-SOUTH-CHENNAI-ANNA NAGAR", "y": 841, "x": 1359054.99, "value": "0.12", "color": "#d51f30" }, { "name": "BF-SOUTH-CHENNAI-BRIGADE VANTAGE", "y": 834, "x": 1108432.01, "value": "0.10", "color": "#d51f30" }, { "name": "BF-SOUTH-CHENNAI-PALLIKARANAI", "y": 883, "x": 1181648.01, "value": "0.11", "color": "#d51f30" }, { "name": "BF-SOUTH-HUBLI-VENKATAGIRI PLAZA", "y": 3456, "x": 2719018.03, "value": "0.25", "color": "#db7823" }, { "name": "BF-SOUTH-MANGALORE-MAK MALL", "y": 1929, "x": 1726174.02, "value": "0.16", "color": "#d51f30" }, { "name": "BF-SOUTH-MYSORE-KEERTHANA COMPLEX", "y": 1858, "x": 2603776.93, "value": "0.24", "color": "#d51f30" }, { "name": "BF-SOUTH-SALEM-NARASUS MURALI TOWERS", "y": 1247, "x": 1322975.99, "value": "0.12", "color": "#d51f30" }, { "name": "BF-SOUTH-THIRUVANANTHAPURAM", "y": 919, "x": 1442298, "value": "0.13", "color": "#d51f30" }, { "name": "BF-WEST-AHM-ACOPOLIS MALL", "y": 2183, "x": 2327920.04, "value": "0.21", "color": "#d51f30" }, { "name": "BF-WEST-AHM-CITY GOLD MALL", "y": 4779, "x": 5754212.05, "value": "0.52", "color": "#d51f30" }, { "name": "BF-WEST-AURANGABAD-MOTIWALA SQUARE", "y": 2188, "x": 3132532.07, "value": "0.28", "color": "#db7823" }, { "name": "BF-WEST-BHUJ-SEVEN SKY MALL", "y": 1252, "x": 1279274, "value": "0.12", "color": "#d51f30" }, { "name": "BF-WEST-INDORE-LIG", "y": 1653, "x": 2311935.02, "value": "0.21", "color": "#d51f30" }, { "name": "BF-WEST-INDORE-PHOOTI KOOTHI", "y": 1535, "x": 2112618.01, "value": "0.19", "color": "#d51f30" }, { "name": "BF-WEST-JABALPUR-COMMERCIAL AUTOMOBILES BLDG.", "y": 1228, "x": 2217351, "value": "0.20", "color": "#db7823" }, { "name": "BF-WEST-KALYAN-SARVODAYA MALL", "y": 2726, "x": 3126113.06, "value": "0.28", "color": "#db7823" }, { "name": "BF-WEST-MUMBAI-ANDHERI-TIME SQUARE", "y": 5403, "x": 2287558, "value": "0.21", "color": "#d51f30" }, { "name": "BF-WEST-MUMBAI-FRAMJEE-DHOBI TALAO", "y": 1960, "x": 2720529.99, "value": "0.25", "color": "#db7823" }, { "name": "BF-WEST-MUMBAI-GHATKOPAR", "y": 1539, "x": 2743617.01, "value": "0.25", "color": "#d51f30" }, { "name": "BF-WEST-MUMBAI-KANDIVALI-V SOUK-MAH", "y": 1636, "x": 2935269, "value": "0.27", "color": "#d51f30" }, { "name": "BF-WEST-MUMBAI-MALAD-UMANG TOWER", "y": 2195, "x": 3548696.99, "value": "0.32", "color": "#db7823" }, { "name": "BF-WEST-MUMBAI-SOBO CENTRAL", "y": 3253, "x": 5266553.97, "value": "0.48", "color": "#d51f30" }, { "name": "BF-WEST-NASHIK-TRIMBAK NAKA", "y": 2019, "x": 2423582.98, "value": "0.22", "color": "#d51f30" }, { "name": "BF-WEST-PUNE-KROME MALL", "y": 1260, "x": 2152570.06, "value": "0.19", "color": "#d51f30" }, { "name": "BF-WEST-PUNE-MODI MALL", "y": 2721, "x": 3713830.97, "value": "0.34", "color": "#d51f30" }, { "name": "BF-WEST-PUNE-PIMPALE-ROSE ICON MALL", "y": 1468, "x": 1908161.02, "value": "0.17", "color": "#d51f30" }, { "name": "BF-WEST-PUNE-PREMIER PLAZA-CHINCHAW", "y": 1619, "x": 1844138.98, "value": "0.17", "color": "#d51f30" }, { "name": "BF-WEST-PUNE-SINHAGAD ROAD", "y": 2487, "x": 2764063.98, "value": "0.25", "color": "#d51f30" }, { "name": "BF-WEST-PUNE-XION MALL", "y": 2200, "x": 1984389.02, "value": "0.18", "color": "#d51f30" }, { "name": "BF-WEST-RAJKOT", "y": 1137, "x": 2108312.02, "value": "0.19", "color": "#db7823" }, { "name": "BF-WEST- SURAT-ROYAL TRADE CENTER", "y": 1596, "x": 2394680, "value": "0.22", "color": "#db7823" }, { "name": "BF-WEST-SURAT-VIP ROAD", "y": 1563, "x": 2246532.01, "value": "0.20", "color": "#db7823" }, { "name": "BF-WEST-THANE-MIRA ROAD", "y": 2705, "x": 4057757.97, "value": "0.37", "color": "#d51f30" }, { "name": "BF-WEST-UJJAIN-COSMOS MALL", "y": 1068, "x": 1414631.01, "value": "0.13", "color": "#db7823" }, { "name": "BF-WEST-VADODARA-RAAMA ICON", "y": 1726, "x": 2305321.01, "value": "0.21", "color": "#db7823" }, { "name": "BF-WEST-VASAI-DATTANI CUBE", "y": 2645, "x": 2947143.03, "value": "0.27", "color": "#db7823" }, { "name": "BF-WEST-VASHI-RAGHULEELA MALL", "y": 5075, "x": 4854290.99, "value": "0.44", "color": "#db7823" }, { "name": "Himayat Nagar,Hyderabad", "y": 2406, "x": 1771110.98, "value": "0.16", "color": "#d51f30" }, { "name": "BF-AHMEDABAD-CHANDKHEDA", "y2": 2348, "x2": 2463654.98, "value2": "0.22", "color": "#db7823" }, { "name": "BF-AHMEDABAD-PRISM-MANINAGAR", "y2": 3162, "x2": 2012095.98, "value2": "0.18", "color": "#d51f30" }, { "name": "BF-AHMEDABAD-TAGORE ROAD", "y2": 1185, "x2": 1561534.97, "value2": "0.14", "color": "#db7823" }, { "name": "BF-AHMEDABAD-VIJAY CROSS ROAD", "y2": 2370, "x2": 1842185, "value2": "0.17", "color": "#db7823" }, { "name": "BF-APTL-HYD-DILSUKHNAGAR", "y2": 6313, "x2": 8001256.99, "value2": "0.72", "color": "#d51f30" }, { "name": "BF-APTL-TIRUPATI-JAH COMPLEX", "y2": 1566, "x2": 1822932.98, "value2": "0.16", "color": "#d51f30" }, { "name": "BF-EAST-CUTTACK-MISSION ROAD", "y2": 2270, "x2": 2038651.97, "value2": "0.18", "color": "#d51f30" }, { "name": "BF-EAST-GANGTOK-TADGONG", "y2": 623, "x2": 742701, "value2": "0.07", "color": "#d51f30" }, { "name": "BF-EAST-SILIGURI-S F ROAD", "y2": 1278, "x2": 2041816.99, "value2": "0.18", "color": "#d51f30" }, { "name": "BF-KOLLOM-SOORYA ENCLAVE", "y2": 1198, "x2": 1383860.98, "value2": "0.13", "color": "#d51f30" }, { "name": "BF-NEW DELHI-INDRALOK METRO ST", "y2": 1724, "x2": 2335825.97, "value2": "0.21", "color": "#038673" }, { "name": "BF-NORTH-DEHRADUN-DARSHINI TOWERS", "y2": 1216, "x2": 1456435.97, "value2": "0.13", "color": "#d51f30" }, { "name": "BF-NORTH-Janakpuri", "y2": 585, "x2": 1230022.98, "value2": "0.11", "color": "#d51f30" }, { "name": "BF-RANCHI BUTALA MALL", "y2": 4142, "x2": 2268952.04, "value2": "0.21", "color": "#d51f30" }, { "name": "BF-SOUTH-KANNUR-METRO SQUARE", "y2": 1055, "x2": 1293068.03, "value2": "0.12", "color": "#d51f30" }, { "name": "BF-SOUTH-MARGAO", "y2": 693, "x2": 980694, "value2": "0.09", "color": "#d51f30" }, { "name": "BF-THRISSUR-SREE SANKARA HALL", "y2": 2460, "x2": 1634039.02, "value2": "0.15", "color": "#d51f30" }, { "name": "BF-WEST-AMRAVATI", "y2": 2277, "x2": 2135772, "value2": "0.19", "color": "#d51f30" }, { "name": "BF-WEST-ANAND-GALLERIA MALL", "y2": 1649, "x2": 2335590.97, "value2": "0.21", "color": "#038673" }, { "name": "BF-WEST-LATUR", "y2": 1473, "x2": 1817900, "value2": "0.16", "color": "#db7823" }]
      , treegraph: '[{"name":"PB","children":[{"name":"PB1","value":350},{"name":"PB2","value":400}]},{"name":"FLFL","children":[{"name":"FLFL1","value":350},{"name":"FLFL2","value":400}]},{"name":"Footwear","children":[{"name":"Men","value":350},{"name":"Women","value":400}]},{"name":"Sports","children":[{"name":"Men","value":350},{"name":"Women","value":400}]},{"name":"Luggage & Bagpacks","children":[{"name":"Luggage","value":350},{"name":"Bagpacks","value":400}]},{"name":"Accessaries","children":[{"name":"Men","value":350},{"name":"Women","value":400}]}]',
      customerdata: [{ "name": "Affluent Customers", "value": 40 }, { "name": "Loyal Customers", "value": 15 }, { "name": "Risk to Churn Customers", "value": 20 }, { "name": "High Net Worth Individuals", "value": 25 }],
      custprofiledata: [{ "category": "WK1", "value1": "25", "value2": "20", "value3": "15", "value4": "40" }, { "category": "WK2", "value1": "25", "value2": "20", "value3": "15", "value4": "40" }, { "category": "WK3", "value1": "25", "value2": "20", "value3": "15", "value4": "40" }, { "category": "WK4", "value1": "25", "value2": "20", "value3": "15", "value4": "40" }, { "category": "WK5", "value1": "25", "value2": "20", "value3": "15", "value4": "40" }, { "category": "WK6", "value1": "25", "value2": "20", "value3": "15", "value4": "40" }],
      selectedSubNav: 'Sale',
      Top5Movers: '',
      Bottom5Movers: '',

      is_scroll: false,

      static_start_date: "",
      first_start_date: props.start_date,
      first_end_date: props.end_date,
      second_start_date: props.previous_start_date,
      second_end_date: props.previous_end_date,
      isDatePickerOpen: false,

      // MAP
      map_zone: '',
      map_state: '',
      map_city: '',
      map_store_code: "",
      map_store_name: '',


      // MAP FILTER
      map_store_category: '',
      map_store_type: '',
      map_store_size: '',

      mapBreadcrumbList: [],
      mapBreadcrumbsNorthPoint: '',
      mapBreadcrumbsSouthPoint: '',
      mapBreadcrumbsCenterPoint: '',

      data: "",
      MapMarker: "",
      North_point: [72.6416015625, 37.71859032558816],
      South_point: [93.1640625, 5.7908968128719565],
      map_level: 0,
      center_point: [0, 0],

      custom_current_basket_size: 5.67,
      custom_last_basket_size: 5.35,
      is_category_deep_dive_loaded: false,
      Deep_Dive_level: 0,
      Deep_Dive_Name: [],
      rangetype: "store_score",
      //map filter
      map_filter_category_list: [
        { name: 'Metro', checked: false },
        { name: 'Non-Metro', checked: false },
      ],
      map_filter_storetype_list: [
        { name: 'New', checked: false },
        { name: 'LTL', checked: false },
        { name: 'Mature', checked: false },
      ],
      map_filter_storesize_list: [],

    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props != nextProps) {
      this.setState({
        first_start_date: nextProps.start_date,
        first_end_date: nextProps.end_date,
        second_start_date: nextProps.previous_start_date,
        second_end_date: nextProps.previous_end_date,
      });
    }
  }

  componentDidMount() {
    this.state.is_India_map_loaded = false;

    this.state.country = this.props.country;

    // Always set Revenue tab as active on mount
    this.setState({ selectedSubNav: 'Revenue' });

    this.getMapdetails();
    this.PageFunctionCall();
    this.forceUpdate();

    window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.start_date !== this.props.start_date ||
      prevProps.end_date !== this.props.end_date ||
      prevProps.previous_start_date !== this.props.previous_start_date ||
      prevProps.previous_end_date !== this.props.previous_end_date
    ) {
      this.PageFunctionCall();
    }
    // Reload on global brand change
    if (prevProps.globalSelectedBrand !== this.props.globalSelectedBrand) {
      this.setState({ selectedBrandDropdownOption: this.props.globalSelectedBrand });
      this.PageFunctionCall();
    }
  }

  PageFunctionCall() {

    this.state.is_storehealth_businessscore_loaded = false;
    this.state.is_businessscoreTrend_loaded = false;
    this.state.is_storedetails_loaded = false;
    this.state.is_StoreScoreStoreSale_parameters_loaded = false;
    this.state.is_StoreScoreStoreCustomer_parameters_loaded = false;
    this.state.is_StoreScoreStorePresence_parameters_loaded = false;
    this.state.is_StoreScoreCategory_parameters_loaded = false;
    this.state.is_StoreScoreOverview_parameters_loaded = false;
    this.state.is_StoreTopBottomMover_parameters_loaded = false;
    this.state.is_store_parameters_loaded = false;
    this.state.is_store_deep_bubble_chart_loaded = false;
    this.state.is_category_deep_dive_loaded = false;

    this.getStoreHealthBusinessScore();
    this.getStoreHealthSparkLineScoreTrendCard();
    if (this.state.map_level == 2) {
      this.getStoreHealthStoreDetails();
    }
    this.getStoreScoreSales()
    this.getStoreScoreCustomer()
    this.getStoreScorePresence()
    this.getStoreScoreCategory()
    this.getStoreScoreOverview()
    this.getStoreTopBottomMover()
    this.getStoreParameters()
    this.getStoreDeepDriveBubbleChart()
    this.getCategoryDeepDive()
    this.getSalesMetrices()
    this.getCustomerMetrices()
  }

  getUrlCountryParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if ((sParameterName[0]).toLowerCase() === sParam.toLowerCase()) {
        return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return "";
  }

  isNull(object) {
    for (const [key, value] of Object.entries(object)) {
      if (typeof value === "object" && value !== null) {
        this.isNull(value);
      } else if (!value) {
        object[key] = 0;
      }
    }
    return object;
  }

  //India map details
  getMapdetails() {
    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;
    let country = this.state.country != null ? (this.state.country).toUpperCase() : "IN";


    const url = API_URL + "ri/zones/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size +
        "&country=" + country +
        (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? ("&brand_id=" + this.props.globalSelectedBrand.value) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result1) => {
          let varIndiaMapData = result1.data;
          this.setState({
            MapMarker: varIndiaMapData,
            is_India_map_loaded: true
          });
        },
        (error) => { }
      );
  }

  getIndiaMapCityDetails() {
    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let map_zone = this.state.map_zone;
    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/cities/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&map_zone=" + map_zone +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? ("&brand_id=" + this.props.globalSelectedBrand.value) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result1) => {
          let varIndiaMapData = result1.data;
          this.setState({
            MapMarker: varIndiaMapData,
            is_India_map_loaded: true,
            map_level: 1
          });
        },
        (error) => { }
      );

  }

  getIndiaMapStoresDetails() {
    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/stores/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? ("&brand_id=" + this.props.globalSelectedBrand.value) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result1) => {
          let varIndiaMapData = result1.data;
          this.setState({
            MapMarker: varIndiaMapData,
            is_India_map_loaded: true,
            map_level: 2
          });
        },
        (error) => { }
      );

  }

  //api callsss
  // SALES METRICES
  getStoreParameters() {

    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_storeparameter/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? "&brand_id=" + this.props.globalSelectedBrand.value : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          let result1 = result;

          //NSV
          let current_target_nsv = result1["current_store_list"][0]["nsv"];
          let current_target_nsv_achieved = result1["last_store_list"][0]["nsv"];
          let tooltip_nsv_target = result1["current_store_list"][0]["target_nsv"];
          let tooltip_nsv_achieved = result1["current_store_list"][0]["nsv_ach"];

          //FootFall
          let current_target_footfalls = result1["current_store_list"][0]["footfalls"];
          let current_footfalls_achieved = result1["last_store_list"][0]["footfalls"];
          let tooltip_footfalls_target = result1["current_store_list"][0]["target_footfalls"];
          let tooltip_footfalls_achieved = result1["current_store_list"][0]["footfalls_achieved"];


          //bills
          let current_target_bills = result1["current_store_list"][0]["bills"];
          let current_target_bills_achieved = result1["last_store_list"][0]["bills"];
          let tooltip_bills_target = result1["current_store_list"][0]["target_bills"];
          let tooltip_bills_achieved = result1["current_store_list"][0]["bills_achieved"];

          //Ats
          let current_target_ats = result1["current_store_list"][0]["ats"];
          let current_target_ats_achieved = result1["last_store_list"][0]["ats"];
          let tooltip_ats_target = result1["current_store_list"][0]["target_ats"];
          let tooltip_ats_achieved = result1["current_store_list"][0]["ats_achieved"];


          //net margin
          let current_target_net_margin = result1["current_store_list"][0]["net_margin"];
          let current_target_net_margin_achieved = result1["last_store_list"][0]["net_margin"];

          let tooltip_net_margin_target = result1["current_store_list"][0]["target_net_margin"];
          let tooltip_net_margin_achieved = result1["current_store_list"][0]["net_margin_achieved"];

          //basket size
          let current_current_basket_size = result1["current_store_list"][0]["basket_size"];
          let current_current_basket_size_achieved = result1["last_store_list"][0]["basket_size"];

          let tooltip_basket_size_target = result1["current_store_list"][0]["target_basket_size"];
          let tooltip_basket_size_achieved = result1["current_store_list"][0]["basket_size_achieved"];

          //Other Parameters 

          let current_target_units_sold = result1["current_store_list"][0]["units_sold"];
          let current_target_units_sold_achieved = result1["last_store_list"][0]["units_sold"];

          let current_target_sell_through = result1["current_store_list"][0]["sell_through"];
          let current_target_sell_through_achieved = result1["last_store_list"][0]["sell_through"];

          let current_target_conversion_rate = result1["current_store_list"][0]["conversion_rate"];
          let current_conversion_rate_achieved = result1["last_store_list"][0]["conversion_rate"];

          let current_target_returning_rate = result1["current_store_list"][0]["returning_rate"];
          let current_returning_rate_achieved = result1["last_store_list"][0]["returning_rate"];

          let current_target_recovery = result1["current_store_list"][0]["recovery"];
          let current_target_recovery_achieved = 0;//result1["last_store_list"][0]["recovery"];


          //spark line
          let spark_list_nsv = [];
          let spark_list_footfall = [];
          let spark_list_bills = [];
          let spark_list_ats = [];
          let spark_list_net_margin = [];
          let spark_list_basket_size = [];

          let spark_list_units = [];
          let spark_list_sell_through = [];
          let spark_list_conversion_rate = [];
          let spark_list_customer_returining_rate = [];

          let store_sparkline_list = result1['store_sparkline_list']

          store_sparkline_list.map((info, index) => {
            try {
              let a = {
                "date": info['datetime'],
                "value": info['nsv']
              }
              spark_list_nsv.push(a);

              let b = {
                "date": info['datetime'],
                "value": info['footfalls']
              }
              spark_list_footfall.push(b);

              let c = {
                "date": info['datetime'],
                "value": info['bills']
              }
              spark_list_bills.push(c);


              let d = {
                "date": info['datetime'],
                "value": info['ats']
              }
              spark_list_ats.push(d);

              let e = {
                "date": info['datetime'],
                "value": info['net_margin']
              }
              spark_list_net_margin.push(e);

              let f = {
                "date": info['datetime'],
                "value": info['basket_size']
              }
              spark_list_basket_size.push(f);

              let g = {
                "date": info['datetime'],
                "value": info['units_sold']
              }
              spark_list_units.push(g);

              let h = {
                "date": info['datetime'],
                "value": info['sell_through']
              }
              spark_list_sell_through.push(h);


              let i = {
                "date": info['datetime'],
                "value": info['conversion_rate']
              }
              spark_list_conversion_rate.push(i);

              let j = {
                "date": info['datetime'],
                "value": info['returning_rate']
              }
              spark_list_customer_returining_rate.push(j);

            } catch (e) {

            }



          })


          this.setState({
            current_target_nsv: current_target_nsv,
            current_target_nsv_achieved: current_target_nsv_achieved,
            current_target_footfalls: current_target_footfalls,
            current_footfalls_achieved: current_footfalls_achieved,
            current_target_bills: current_target_bills,
            current_target_bills_achieved: current_target_bills_achieved,
            current_target_ats: current_target_ats,
            current_target_ats_achieved: current_target_ats_achieved,
            current_target_net_margin: current_target_net_margin,
            current_target_net_margin_achieved: current_target_net_margin_achieved,
            current_current_basket_size: current_current_basket_size,
            current_current_basket_size_achieved: current_current_basket_size_achieved,
            current_target_units_sold: current_target_units_sold,
            current_target_units_sold_achieved: current_target_units_sold_achieved,
            current_target_sell_through: current_target_sell_through,
            current_target_sell_through_achieved: current_target_sell_through_achieved,
            current_target_conversion_rate: current_target_conversion_rate,
            current_conversion_rate_achieved: current_conversion_rate_achieved,
            current_target_returning_rate: current_target_returning_rate,
            current_returning_rate_achieved: current_returning_rate_achieved,
            current_target_recovery: current_target_recovery,
            current_target_recovery_achieved: current_target_recovery_achieved,
            spark_list_nsv: spark_list_nsv,
            spark_list_footfall: spark_list_footfall,
            spark_list_bills: spark_list_bills,
            spark_list_ats: spark_list_ats,
            spark_list_net_margin: spark_list_net_margin,
            spark_list_basket_size: spark_list_basket_size,
            spark_list_units: spark_list_units,
            spark_list_sell_through: spark_list_sell_through,
            spark_list_conversion_rate: spark_list_conversion_rate,
            spark_list_customer_returining_rate: spark_list_customer_returining_rate,
            tooltip_nsv_target: tooltip_nsv_target,
            tooltip_nsv_achieved: tooltip_nsv_achieved,
            tooltip_footfalls_target: tooltip_footfalls_target,
            tooltip_footfalls_achieved: tooltip_footfalls_achieved,
            tooltip_bills_target: tooltip_bills_target,
            tooltip_bills_achieved: tooltip_bills_achieved,
            tooltip_ats_target: tooltip_ats_target,
            tooltip_ats_achieved: tooltip_ats_achieved,
            tooltip_net_margin_target: tooltip_net_margin_target,
            tooltip_net_margin_achieved: tooltip_net_margin_achieved,
            tooltip_basket_size_target: tooltip_basket_size_target,
            tooltip_basket_size_achieved: tooltip_basket_size_achieved,
            is_store_parameters_loaded: true,
          });
        },
        (error) => { }
      );
  }
  //eod SALES METRICES

  //Top -bottom mover
  getStoreTopBottomMover() {

    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_movers/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? "&brand_id=" + this.props.globalSelectedBrand.value : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          let result1 = result;
          let top_mover_list = result1["top_mover_list"];
          let bottom_mover_list = result1["bottom_mover_list"];

          this.setState({
            Top5Movers: top_mover_list,
            Bottom5Movers: bottom_mover_list,
            is_StoreTopBottomMover_parameters_loaded: true,
          });
        },
        (error) => { }
      );
  }
  // eod Top -bottom mover

  //store scrore overview 
  getStoreScoreOverview() {

    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_scoreoverview/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size +
        (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? ("&brand_id=" + this.props.globalSelectedBrand.value) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          let result1 = result;

          let top_score_list = result1["top_score_list"];
          let bottom_score_list = result1["bottom_score_list"];
          let topstoredata_list = [];
          let bottomstoredata_list = [];

          top_score_list.map((info, index) => {
            try {
              let topstoredata = {
                category: String(info['store_code']),
                value: info['score'],
                customtooltiptext: info['site_desc'],
              };
              topstoredata_list.push(topstoredata)
            } catch (e) { }
          });
          bottom_score_list.map((info, index) => {
            try {
              let bottomstoredata = {
                category: String(info['store_code']),
                value: info['score'],
                customtooltiptext: info['site_desc'],
              };
              bottomstoredata_list.push(bottomstoredata)
            } catch (e) { }
          });

          this.setState({
            topstoredata: topstoredata_list,
            bottomstoredata: bottomstoredata_list,
            is_StoreScoreOverview_parameters_loaded: true,
          });
        },
        (error) => { }
      );
  }
  //eod store scrore overview


  //Category 
  getStoreScoreCategory() {

    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_category/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size +
        (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? ("&brand_id=" + this.props.globalSelectedBrand.value) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          let result1 = result;

          let storehealth_StoreCategory = result1;
          this.setState({
            storehealth_StoreCategory: storehealth_StoreCategory,
            is_StoreScoreCategory_parameters_loaded: true,
          });
        },
        (error) => { }
      );
  }

  //eod category 

  //Presence
  getStoreScorePresence() {

    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_presence/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? "&brand_id=" + this.props.globalSelectedBrand.value : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {

          let storepresence_max_carpet_area = parseFloat(result["presence_list"][0].max_carpet_area).toFixed(2);
          let storepresence_avg_carpet_area = parseFloat(result["presence_list"][0].avg_carpet_area).toFixed(2);
          let storepresence_min_carpet_area = parseFloat(result["presence_list"][0].min_carpet_area).toFixed(2);

          this.setState({
            storepresence_max_carpet_area: storepresence_max_carpet_area,
            storepresence_avg_carpet_area: storepresence_avg_carpet_area,
            storepresence_min_carpet_area: storepresence_min_carpet_area,
            is_StoreScoreStorePresence_parameters_loaded: true,
          });
        },
        (error) => { }
      );
  }
  // EOD Presence

  //Sales
  getStoreScoreSales() {

    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_sale/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? "&brand_id=" + this.props.globalSelectedBrand.value : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          let result1 = result;
          let store_sale_data = result1;
          this.setState({
            store_sale_data: store_sale_data,
            is_StoreScoreStoreSale_parameters_loaded: true,
          });
        },
        (error) => { }
      );
  }
  //EOD Sales


  //Customer
  getStoreScoreCustomer() {

    let result = [];
    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_customer/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size +
        (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? ("&brand_id=" + this.props.globalSelectedBrand.value) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          let result1 = result;
          let StoreCustomer_data = result1;
          this.setState({
            StoreCustomer_data: StoreCustomer_data,
            is_StoreScoreStoreCustomer_parameters_loaded: true,
          });
        },
        (error) => { }
      );
  }
  //EOD Customer
  //Store 
  // BUSINESS SCORE FILTER
  getStoreHealthBusinessScore() {
    // DATE PICKER 
    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //MAP
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //MAP FILTER
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;


    // const data = {
    //   start_date: "2022-01-20",
    //   end_date: "2022-01-22",
    // };
    const url = API_URL + "ri/branch_storescore/";

    fetch(url, {
      method: "POST",
      body:
        'start_date=' + start_date +
        '&end_date=' + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&storecode=" + storecode +
        "&map_city=" + map_city +
        "&state=" + state +
        "&storename=" + storename +
        "&store_type=" + store_type +
        "&city_type=" + category +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? "&brand_id=" + this.props.globalSelectedBrand.value : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then((result) => {

        let storehealth_businessNew = result.business;
        let storehealth_saleNew = result.sale;
        let storehealth_customerNew = result.customer;
        let storehealth_presence = result.presence;
        let storehealth_category = result.category;

        let storehealth_graph_pointer_business = Math.round(result.graph_pointer.business);
        let storehealth_graph_pointer_sale = Math.round(result.graph_pointer.sales);
        let storehealth_graph_pointer_customer = Math.round(result.graph_pointer.customer);
        let storehealth_graph_pointer_presence = Math.round(result.graph_pointer.presence);
        let storehealth_graph_pointer_category = Math.round(result.graph_pointer.category);

        this.setState({
          storehealth_businessNew: storehealth_businessNew,
          storehealth_sale: storehealth_saleNew,
          storehealth_customer: storehealth_customerNew,
          storehealth_presence: storehealth_presence,
          storehealth_category: storehealth_category,
          storehealth_graph_pointer_business: storehealth_graph_pointer_business,
          storehealth_graph_pointer_sale: storehealth_graph_pointer_sale,
          storehealth_graph_pointer_customer: storehealth_graph_pointer_customer,
          storehealth_graph_pointer_presence: storehealth_graph_pointer_presence,
          storehealth_graph_pointer_category, storehealth_graph_pointer_category,
          is_storehealth_businessscore_loaded: true,
        });

      });
  }
  // 

  //scrore trend 
  // MATRIC SPARK LINE MATRIC SPARK LINE 
  getStoreHealthSparkLineScoreTrendCard() {
    // DATE PICKER 
    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //MAP
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //MAP FILTER
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_storetrend/";

    fetch(url, {
      method: "POST",
      body:

        'start_date=' + start_date +
        '&end_date=' + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? ("&brand_id=" + this.props.globalSelectedBrand.value) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then((result) => {
        let overall_data_sparkline_list = result["overall_data_sparkline"];
        let sales_data_sparkline_list = result["sales_data_sparkline"];
        let customer_data_sparkline_list = result["customer_data_sparkline"];
        let presence_data_sparkline_list = result["presence_data_sparkline"];
        let category_data_sparkline_list = result["category_data_sparkline"];
        let overall_data_list = [];
        let sales_data_list = [];
        let customer_data_list = [];
        let presence_data_list = [];
        let category_data_list = [];

        overall_data_sparkline_list.map((info, index) => {
          try {
            let overall_data = {
              date: info['day'],
              value: info['overall_score'],
            };
            overall_data_list.push(overall_data)
          } catch (e) { }
        });

        sales_data_sparkline_list.map((info, index) => {
          try {
            let sales_data = {
              date: info['day'],
              value: info['sales_score'],
            };
            sales_data_list.push(sales_data)
          } catch (e) { }
        });

        customer_data_sparkline_list.map((info, index) => {
          try {
            let customer_data = {
              date: info['day'],
              value: info['customer_score'],
            };
            customer_data_list.push(customer_data)
          } catch (e) { }
        });

        presence_data_sparkline_list.map((info, index) => {
          try {
            let presence_data = {
              date: info['day'],
              value: info['presence_score'],
            };
            presence_data_list.push(presence_data)
          } catch (e) { }
        });

        category_data_sparkline_list.map((info, index) => {
          try {
            let category_data = {
              date: info['day'],
              value: info['category_score'],
            };
            category_data_list.push(category_data)
          } catch (e) { }
        });

        this.setState({
          linesparkgraph_overall_StoreHealth: overall_data_list,
          linesparkgraph_sales_StoreHealth: sales_data_list,
          linesparkgraph_customer_StoreHealth: customer_data_list,
          linesparkgraph_presence_StoreHealth: presence_data_list,
          linesparkgraph_category_StoreHealth: category_data_list,
          is_businessscoreTrend_loaded: true,
        });
      });
  }


  // MATRIC SPARK LINE MATRIC SPARK LINE 
  getStoreHealthStoreDetails() {
    // DATE PICKER 
    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //MAP
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //MAP FILTER
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_storedetails/";

    fetch(url, {
      method: "POST",
      body:
        'start_date=' + start_date +
        '&end_date=' + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size +
        (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? ("&brand_id=" + this.props.globalSelectedBrand.value) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then((result) => {
        let storedetails_list = result["storedetails_list"];
        let storehealth_storeScoreRank = 0;
        let storehealth_StoreCode = 0;
        let storehealth_StoreManager = 0;
        let storehealth_StoreOpeningDate = 0;
        let storehealth_StoreCarpetArea = 0;
        if (storedetails_list != undefined) {
          storehealth_storeScoreRank = storedetails_list[0].score;
          storehealth_StoreCode = storedetails_list[0].store_code;
          storehealth_StoreManager = storedetails_list[0].store_manager;
          storehealth_StoreOpeningDate = storedetails_list[0].opening_date;
          storehealth_StoreCarpetArea = storedetails_list[0].carpet_area;
        }
        this.setState({
          storehealth_storeScoreRank: storehealth_storeScoreRank,
          storehealth_StoreCode: storehealth_StoreCode,
          storehealth_StoreManager: storehealth_StoreManager,
          storehealth_StoreOpeningDate: storehealth_StoreOpeningDate,
          storehealth_StoreCarpetArea: storehealth_StoreCarpetArea,
          is_storedetails_loaded: true,
        });
      });
  }


  //business overview
  getStoreDeepDriveBubbleChart() {
    // DATE PICKER 
    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    // DROP DWON FILTER
    let footfalls_dropdown_value = this.state.footfalls_dropdown_value;
    let nsv_dropdown_value = this.state.nsv_dropdown_value

    //
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //MAP FILTER
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/branch_businessoverview/";

    fetch(url, {
      method: "POST",
      body:
        'start_date=' + start_date +
        '&end_date=' + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? "&brand_id=" + this.props.globalSelectedBrand.value : ""),

      headers: {
        "Content-Type": 'application/x-www-form-urlencoded',
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then((result) => {
        console.debug(result);
        let store_attribution_bubble_list = result['business_overview_list'];
        let store_attribution_bubble_chart_list = [];
        store_attribution_bubble_list.map((info, index) => {

          try {
            let ytemp = "y" + index.toString();
            let xtemp = "x" + index.toString();
            let valuetemp = "value" + index.toString();
            var b = "y" + (0).toString();

            let storeColor = "";
            storeColor =
              (info['nsv_ach']) * 100 < 70
                ? "#d51f30"
                : (info['nsv_ach']) * 100 < 94
                  ? "#db7823"
                  : "#038673";


            if (info['store_type'] == 'NEW') {
              let a = {
                name: info['site_desc'],
                y2: (info[footfalls_dropdown_value]),
                x2: info[nsv_dropdown_value],
                value2: (info['nsv_mix']) + "",
                color: storeColor,
              };

              store_attribution_bubble_chart_list.push(a);
            } else if (info["store_type"] == "MATURE") {
              let a = {
                name: info['site_desc'],
                y: (info[footfalls_dropdown_value]),
                x: info[nsv_dropdown_value],
                value1: (info['nsv_mix']) + "",
                color: storeColor,
              };
              store_attribution_bubble_chart_list.push(a);
            } else {
              let a = {
                name: info['site_desc'],
                y3: (info[footfalls_dropdown_value]),
                x3: info[nsv_dropdown_value],
                value3: (info['nsv_mix']) + "",
                color: storeColor,
              };
              store_attribution_bubble_chart_list.push(a);
            }

          } catch (e) { }
        });

        this.setState({
          is_store_deep_bubble_chart_loaded: true,
          storehealth_storedata: store_attribution_bubble_chart_list,
        });
      });
  }
  //eod  business overview

  //deep dive
  // CATEGPRY NSV DEEP DIVE CHART
  getCategoryDeepDive() {
    // DATE PICKER 
    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //MAP
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //MAP FILTER
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    // NSV DEEP DIVES
    let Deep_Dive_level = this.state.Deep_Dive_level;
    let Deep_Dive_Name = this.state.Deep_Dive_Name;

    const url = API_URL + "ri/branch_categoryassortment/";

    fetch(url, {
      method: 'POST',
      body:
        'start_date=' + start_date +
        '&end_date=' + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&level=" + Deep_Dive_level +
        "&name=" + Deep_Dive_Name +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size
        + (this.props.globalSelectedBrand && this.props.globalSelectedBrand.value ? "&brand_id=" + this.props.globalSelectedBrand.value : ""),

      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then(res => res.json())
      .then((result) => {
        let category_nsv_deep_dives_list = result;

        this.setState({
          Store_health_category_deep_dive_graph: category_nsv_deep_dives_list,
          is_category_deep_dive_loaded: true,
        });
      });
  }
  //
  //eod scrore trend

  //eod api call

  getSalesMetrices() {

    let result = [];

    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/ri-summarybranchsales/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size +
        (this.props.globalSelectedBrandIds ? ("&brand_id=" + this.props.globalSelectedBrandIds) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          let result1 = result;

          let current_net_margin;
          let last_net_margin;
          let current_average_ticket_size;
          let last_average_ticket_size;
          let current_sell_through;
          let last_sell_through;
          let current_average_selling_price;
          let last_average_selling_price;
          let current_markdown;
          let last_markdown;
          let current_recovery;
          //let last_recovery;

          let current_target_net_margin;
          let last_target_net_margin;
          let current_target_ats;
          let last_target_ats;
          let current_target_sell_through;
          let last_target_sell_through;
          let current_target_asp;
          let last_target_asp;
          let current_target_markdown;
          let last_target_markdown;
          let current_target_recovery;
          let current_basket_size;
          let last_basket_size;
          let current_target_basket_size;
          let current_pspfo;
          //let last_pspfo;

          let current_target_nsv_achieved;
          let current_target_net_margin_achieved;
          let current_target_bills_achieved;
          let current_target_ats_achieved;
          let current_target_sell_through_achieved;
          let current_target_units_sold_achieved;
          let current_target_asp_achieved;
          let current_target_markdown_achieved;
          let current_target_rgm_achieved;
          let current_basket_size_achieved;

          let current_nsv = result1["current_ri_sales_list"][0]["nsv"];
          let last_nsv = result1["last_ri_sales_list"][0]["nsv"];

          //let current_net_salesvalue = result1['current_ri_sales_lists'][0]['nsv']

          let current_bills = result1["current_ri_sales_list"][0]["bills"];
          let last_bills = result1["last_ri_sales_list"][0]["bills"];

          let current_units_sold = result1["current_ri_sales_list"][0]["units_sold"];
          let last_units_sold = result1["last_ri_sales_list"][0]["units_sold"];

          let current_rgm = result1["current_ri_sales_list"][0]["rgm"];
          let last_rgm = result1["last_ri_sales_list"][0]["rgm"];

          let current_retailarea = result1["current_ri_sales_list"][0]["retailarea"];

          let last_retailarea = result1["last_ri_sales_list"][0]["retailarea"];

          let current_mbq = result1["current_ri_sales_list"][0]["mbq"];
          //let last_mbq = result1['last_ri_sales_list'][0]['mbq']

          let current_soh = result1["current_ri_sales_list"][0]["soh"];
          let last_soh = result1["current_ri_sales_list"][0]["soh"];

          let current_tax = result1["current_ri_sales_list"][0]["tax"];
          let last_tax = result1["last_ri_sales_list"][0]["tax"];

          let current_gsv = result1["current_ri_sales_list"][0]["gsv"];
          let last_gsv = result1["last_ri_sales_list"][0]["gsv"];

          let current_target_nsv = result1["current_ri_sales_list"][0]["target_nsv"];
          let last_target_nsv = result1["current_ri_sales_list"][0]["target_nsv"];

          let current_target_bills = result1["current_ri_sales_list"][0]["target_bills"];
          let last_target_bills = result1["current_ri_sales_list"][0]["target_bills"];

          let current_target_units_sold = result1["current_ri_sales_list"][0]["target_units_sold"];
          let last_target_units_sold = result1["current_ri_sales_list"][0]["target_units_sold"];

          let current_target_rgm = result1["current_ri_sales_list"][0]["target_rgm"];
          let last_target_rgm = result1["current_ri_sales_list"][0]["target_rgm"];

          let current_target_gsv = result1["current_ri_sales_list"][0]["target_gsv"];
          let last_target_gsv = result1["current_ri_sales_list"][0]["target_gsv"];

          let current_target_tax = result1["current_ri_sales_list"][0]["target_tax"];
          let last_target_tax = result1["current_ri_sales_list"][0]["target_tax"];

          // FOR SPARKLINE
          let sparkline_list = result1["ri_sales_metrices_sparkline_list"];
          let sales_nsv_spark_list = [];
          let sales_net_margin_spark_list = [];
          let sales_bills_spark_list = [];
          let sales_ats_spark_list = [];
          let sales_sell_through_spark_list = [];
          let sales_units_sold_spark_list = [];
          let sales_asp_spark_list = [];
          let sales_markdown_spark_list = [];
          let sales_rgm_spark_list = [];
          let sales_basket_size_list = [];
          //let sales_recovery_spark_list = [];

          sparkline_list.map((info, index) => {
            try {
              let a = {
                date: info["datetime"],
                value: parseInt((info["nsv"] * 1).toFixed(2)),
              };
              sales_nsv_spark_list.push(a);

              let b = {
                date: info["datetime"],
                value: (((info["rgm"] * 1) / (info["nsv"] * 1 - info["tax"] * 1)) * 100).toFixed(2),
              };
              sales_net_margin_spark_list.push(b);

              let c = {
                date: info["datetime"],
                value: info["bills"],
              };
              sales_bills_spark_list.push(c);

              let d = {
                date: info["datetime"],
                value: ((info["nsv"] * 1) / info["bills"]).toFixed(2),
              };
              sales_ats_spark_list.push(d);

              let e = {
                date: info["datetime"],
                value: ((info["soh"])).toFixed(2),
              };
              sales_sell_through_spark_list.push(e);

              let f = {
                date: info["datetime"],
                value: info["units_sold"],
              };
              sales_units_sold_spark_list.push(f);

              let g = {
                date: info["datetime"],
                value: ((info["nsv"] * 1) / info["units_sold"]).toFixed(2),
              };
              sales_asp_spark_list.push(g);

              let h = {
                date: info["datetime"],
                value: (info["target_bills"]).toFixed(2),
              };
              sales_markdown_spark_list.push(h);

              let i = {
                date: info["datetime"],
                value: info["rgm"] * 1,
              };
              sales_rgm_spark_list.push(i);

              // let j = {
              //     "date" : info['date'],
              //     "value":info[]

              // }
              // sales_recovery_spark_list.push(j);
              let k = {
                date: info["datetime"],
                value: info["units_sold"] / info["bills"],
              };
              sales_basket_size_list.push(k);
            } catch (e) { }
          });

          // current_net_margin = ((current_rgm / (current_nsv - current_tax)) * 100).toFixed(2);
          current_net_margin = (current_rgm).toFixed(2);

          last_net_margin = (last_rgm).toFixed(2);

          current_average_ticket_size = current_gsv.toFixed(2); // (current_nsv / current_bills).toFixed(2);


          last_average_ticket_size = last_gsv.toFixed(2); // parseFloat(last_nsv / last_bills).toFixed(2);

          current_sell_through = ((current_units_sold / current_soh) * 100).toFixed(2);
          // last_sell_through = ((last_units_sold / last_soh) * 100).toFixed(2);
          last_sell_through = (last_soh).toFixed(2);

          current_average_selling_price = current_tax; // current_nsv / current_units_sold;
          last_average_selling_price = last_tax //last_nsv / last_units_sold;

          current_markdown = current_target_bills.toFixed(2); //) (((current_gsv - current_nsv) / current_gsv) * 100).toFixed(2);
          last_markdown = last_target_bills.toFixed(2); // (((last_gsv - last_nsv) / last_gsv) * 100).toFixed(2);

          current_recovery = ((current_nsv / last_nsv) * 100).toFixed(2);

          current_basket_size = current_target_units_sold; //current_units_sold / current_bills;
          last_basket_size = last_target_units_sold; //last_units_sold / last_bills;

          current_pspfo = (current_nsv / current_retailarea).toFixed(2);

          current_target_basket_size = current_target_units_sold / current_target_bills;

          current_target_net_margin = ((current_target_rgm / (current_target_nsv - current_target_tax)) * 100).toFixed(2);


          // current_target_ats = (current_target_nsv / current_target_bills).toFixed(2);
          current_target_ats = current_target_gsv.toFixed(2);

          // current_target_sell_through = ((current_target_units_sold / current_soh) * 100).toFixed(2);
          current_target_sell_through = ((current_soh)).toFixed(2);
          current_target_asp = current_target_nsv / current_target_units_sold;

          current_target_markdown = (((current_target_gsv - current_target_nsv) / current_target_gsv) * 100).toFixed(2);

          current_target_rgm_achieved = ((current_rgm / current_target_rgm) * 100).toFixed(2);

          current_target_nsv_achieved = ((current_nsv / current_target_nsv) * 100).toFixed(2);


          current_target_net_margin_achieved = ((current_net_margin / current_target_net_margin) * 100).toFixed(2);


          current_target_bills_achieved = ((current_bills / current_target_bills) * 100).toFixed(2);

          current_target_ats_achieved = ((current_average_ticket_size / current_target_ats) * 100).toFixed(2);

          current_target_sell_through_achieved = ((current_sell_through / current_target_sell_through) * 100).toFixed(2);

          current_target_units_sold_achieved = ((current_units_sold / current_target_units_sold) * 100).toFixed(2);

          current_target_asp_achieved = ((current_average_selling_price / current_target_asp) * 100).toFixed(2);

          current_target_markdown_achieved = ((current_markdown / current_target_markdown) * 100).toFixed(2);

          current_basket_size_achieved = ((current_basket_size / current_target_basket_size) * 100).toFixed(2);

          if (
            current_sell_through == "NaN" ||
            current_sell_through == "InfinityG"
          ) {
            current_sell_through = 0;
          }

          // if (current_target_nsv_achieved > 100) {
          //   current_target_nsv_achieved = 100;
          // }

          if (current_target_net_margin_achieved > 100) {
            current_target_net_margin_achieved = 100;
          }

          if (current_target_bills_achieved > 100) {
            current_target_bills_achieved = 100;
          }

          // if(current_target_ats_achieved>100){
          //     current_target_ats_achieved=100
          // }

          if (current_target_sell_through_achieved > 100) {
            current_target_sell_through_achieved = 100;
          }

          if (current_target_units_sold_achieved > 100) {
            current_target_units_sold_achieved = 100;
          }

          if (current_target_asp_achieved > 100) {
            current_target_asp_achieved = 100;
          }

          // if(current_target_markdown_achieved > 100){
          //     current_target_markdown_achieved =100
          // }

          // if(current_basket_size_achieved > 100){
          //     current_basket_size_achieved =100
          // }

          this.setState({

            current_nsv: current_nsv,
            last_nsv: last_nsv,
            current_gsv: current_gsv,
            last_gsv: last_gsv,
            // current_tax_sales:current_tax_sales,
            //last_tax_sales:last_tax_sales,
            current_rgm: current_rgm,
            last_rgm: last_rgm,
            // current_target_nsv_sales:current_target_nsv_sales,
            // last_target_nsv_sales:last_target_nsv_sales,
            // current_target_rgm_sales:current_target_rgm_sales,
            // last_target_rgm_sales:last_target_rgm_sales,
            // current_target_gsv_sales:current_target_gsv_sales,
            // last_target_gsv_sales:last_target_gsv_sales,
            //current_target_tax_sales:current_target_tax_sales,
            // last_target_tax_sales:last_target_tax_sales,

            //current_net_salesvalue:current_net_salesvalue,
            //last_net_salesvalue:last_net_salesvalue,
            current_bills: current_bills,
            last_bills: last_bills,
            current_units_sold: current_units_sold,
            last_units_sold: last_units_sold,
            //current_retail_gross_margin:current_retail_gross_margin,
            //last_retail_gross_margin:last_retail_gross_margin,
            current_soh: current_soh,
            last_soh: last_soh,
            current_tax: current_tax,
            last_tax: last_tax,
            // current_gross_sales_value:current_gross_sales_value,
            //last_gross_sales_value:last_gross_sales_value,
            current_net_margin: current_net_margin,
            last_net_margin: last_net_margin,
            current_average_ticket_size: current_average_ticket_size,
            last_average_ticket_size: last_average_ticket_size,
            current_sell_through: current_sell_through,
            last_sell_through: last_sell_through,
            current_average_selling_price: current_average_selling_price,
            last_average_selling_price: last_average_selling_price,
            current_markdown: current_markdown,
            last_markdown: last_markdown,
            current_recovery: current_recovery,
            //last_recovery :last_recovery
            current_mbq: current_mbq,
            current_basket_size: current_basket_size,
            last_basket_size: last_basket_size,
            current_pspfo: current_pspfo,
            //last_pspfo:last_pspfo,
            current_retailarea: current_retailarea,
            last_retailarea: last_retailarea,

            current_target_nsv: current_target_nsv,
            last_target_nsv: last_target_nsv,
            current_target_bills: current_target_bills,
            last_target_bills: last_target_bills,
            current_target_units_sold: current_target_units_sold,
            last_target_units_sold: last_target_units_sold,
            current_target_rgm: current_target_rgm,
            last_target_rgm: last_target_rgm,
            current_target_gsv: current_target_gsv,
            last_target_gsv: last_target_gsv,
            current_target_tax: current_target_tax,
            last_target_tax: last_target_tax,
            current_target_net_margin: current_target_net_margin,
            current_target_ats: current_target_ats,
            current_target_sell_through: current_target_sell_through,
            current_target_asp: current_target_asp,
            current_target_markdown: current_target_markdown,
            current_target_basket_size: current_target_basket_size,
            current_target_nsv_achieved: current_target_nsv_achieved,
            current_target_net_margin_achieved: current_target_net_margin_achieved,
            current_target_bills_achieved: current_target_bills_achieved,
            current_target_ats_achieved: current_target_ats_achieved,
            current_target_sell_through_achieved: current_target_sell_through_achieved,
            current_target_units_sold_achieved: current_target_units_sold_achieved,
            current_target_asp_achieved: current_target_asp_achieved,
            current_target_markdown_achieved: current_target_markdown_achieved,
            current_target_rgm_achieved: current_target_rgm_achieved,
            current_basket_size_achieved: current_basket_size_achieved,

            sales_nsv_spark_graph: sales_nsv_spark_list,
            sales_net_margin_spark_graph: sales_net_margin_spark_list,
            sales_bills_spark_graph: sales_bills_spark_list,
            sales_ats_spark_graph: sales_ats_spark_list,
            sales_sell_through_spark_graph: sales_sell_through_spark_list,
            sales_units_sold_spark_graph: sales_units_sold_spark_list,
            sales_asp_spark_graph: sales_asp_spark_list,
            sales_markdown_spark_graph: sales_markdown_spark_list,
            sales_rgm_spark_graph: sales_rgm_spark_list,
            sales_basket_size_graph: sales_basket_size_list,

            is_sales_metrices_loaded: true,
            is_sales_graph_loaded: true,

          });
        },
        (error) => { }
      );

    this.forceUpdate();
  }

  // CUSTOMER METRICES
  getCustomerMetrices() {
    let start_date = this.state.first_start_date;
    let end_date = this.state.first_end_date;
    let previous_start_date = this.state.second_start_date;
    let previous_end_date = this.state.second_end_date;

    //map
    let map_zone = this.state.map_zone;
    let map_city = this.state.map_city;
    let storecode = this.state.map_store_code;
    let storename = this.state.map_store_name;
    let state = this.state.map_state;

    //map filter
    let category = this.state.map_store_category;
    let store_type = this.state.map_store_type;
    let store_size = this.state.map_store_size;

    const url = API_URL + "ri/ri-summarybranchcustomer/";

    fetch(url, {
      method: "POST",
      body: "start_date=" + start_date +
        "&end_date=" + end_date +
        "&last_start_date=" + previous_start_date +
        "&last_end_date=" + previous_end_date +
        "&map_zone=" + map_zone +
        "&map_city=" + map_city +
        "&storecode=" + storecode +
        "&storename=" + storename +
        "&state=" + state +
        "&city_type=" + category +
        "&store_type=" + store_type +
        "&store_size=" + store_size +
        (this.props.globalSelectedBrandIds ? ("&brand_id=" + this.props.globalSelectedBrandIds) : ""),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': ' Bearer ' + localStorage.getItem("token")

      },
    })
      .then((res) => res.json())
      .then(
        (result) => {

          let result1 = result;
          // Map API response to state variables for customer matrix
          let current_total_customers = result1["current_ri_customer_list"][0]["total_customers"];
          let last_total_customers = result1["last_ri_customer_list"][0]["total_customers"];
          let current_new_customer_acquisitions = result1["current_ri_customer_list"][0]["new_customer_acquisitions"];
          let last_new_customer_acquisitions = result1["last_ri_customer_list"][0]["new_customer_acquisitions"];
          let current_customers_lost = result1["current_ri_customer_list"][0]["customers_lost"];
          let last_customers_lost = result1["last_ri_customer_list"][0]["customers_lost"];
          let current_avg_products_per_customer = result1["current_ri_customer_list"][0]["avg_products_per_customer"];
          let last_avg_products_per_customer = result1["last_ri_customer_list"][0]["avg_products_per_customer"];
          let current_conversion_rate = result1["current_ri_customer_list"][0]["conversion_rate"];
          let last_conversion_rate = result1["last_ri_customer_list"][0]["conversion_rate"];
          let current_csat = result1["current_ri_customer_list"][0]["csat"];
          let last_csat = result1["last_ri_customer_list"][0]["csat"];
          let current_customer_retention = result1["current_ri_customer_list"][0]["customer_retention"];
          let last_customer_retention = result1["last_ri_customer_list"][0]["customer_retention"];
          let current_cac = result1["current_ri_customer_list"][0]["cac"];
          let last_cac = result1["last_ri_customer_list"][0]["cac"];
          let current_customer_ltv = result1["current_ri_customer_list"][0]["customer_ltv"];
          let last_customer_ltv = result1["last_ri_customer_list"][0]["customer_ltv"];

          // if (current_footfalls_achieved > 100) {
          //   current_footfalls_achieved = 100;
          // }

          // if (current_conversion_rate_achieved > 100) {
          //   current_conversion_rate_achieved = 100;
          // }

          // if (current_customer_number_achieved > 100) {
          //   current_customer_number_achieved = 100;
          // }
          // if (current_repeating_rate_achieved > 100) {
          //   current_repeating_rate_achieved = 100;
          // }
          // if (current_customer_frequency_achieved > 100) {
          //   current_customer_frequency_achieved = 100;
          // }

          // CUSTOMER SPARKLINE
          let customer_sparkline_list = result1["ri_customer_metrices_sparkline_list"];


          let customer_footfalls_spark_list = [];
          let customer_conversion_rate_spark_list = [];
          let customer_number_spark_list = [];
          let customer_returning_rate_spark_list = [];
          let customer_frequency_spark_list = [];
          let customer_basket_size_list = [];
          let customer_retention_spark_list = [];
          let customer_cac_spark_list = [];
          let customer_ltv_spark_list = [];

          customer_sparkline_list.map((info, index) => {
            // CAC sparkline
            let cac = {
              date: info["datetime"],
              value: info["cac"] !== undefined ? parseFloat(info["cac"]).toFixed(2) : null,
            };
            customer_cac_spark_list.push(cac);

            // Customer LTV sparkline
            let ltv = {
              date: info["datetime"],
              value: info["customer_ltv"] !== undefined ? parseFloat(info["customer_ltv"]).toFixed(2) : null,
            };
            customer_ltv_spark_list.push(ltv);
            try {
              let a = {
                date: info["datetime"],
                value: info["footfall"],
              };
              customer_footfalls_spark_list.push(a);

              let b = {
                date: info["datetime"],
                value: ((info["unique_bills_final"] / info["footfall"]) * 100).toFixed(2),
              };
              customer_conversion_rate_spark_list.push(b);

              let c = {
                date: info["datetime"],
                value: info["unique_customers"],
              };
              customer_number_spark_list.push(c);

              let d = {
                date: info["datetime"],
                value: ((info["unique_customers"] / info["unique_bills_final"]) * 100).toFixed(2),
              };
              customer_returning_rate_spark_list.push(d);

              let e = {
                date: info["datetime"],
                value: (
                  info["unique_bills_final"] / info["unique_customers"]
                ).toFixed(2),
              };
              customer_frequency_spark_list.push(e);

              let f = {
                date: info["datetime"],
                value: (info["units_sold"] / info["unique_bills_final"]).toFixed(2),
              };
              customer_basket_size_list.push(f);

              // Add customer retention sparkline
              let g = {
                date: info["datetime"],
                value: info["customer_retention"] !== undefined ? parseFloat(info["customer_retention"]).toFixed(2) : null,
              };
              customer_retention_spark_list.push(g);
            } catch (e) { }
          });

          this.setState({
            current_total_customers: current_total_customers,
            last_total_customers: last_total_customers,
            current_new_customer_acquisitions: current_new_customer_acquisitions,
            last_new_customer_acquisitions: last_new_customer_acquisitions,
            current_customers_lost: current_customers_lost,
            last_customers_lost: last_customers_lost,
            current_avg_products_per_customer: current_avg_products_per_customer,
            last_avg_products_per_customer: last_avg_products_per_customer,
            current_conversion_rate: current_conversion_rate,
            last_conversion_rate: last_conversion_rate,
            current_csat: current_csat,
            last_csat: last_csat,
            current_customer_retention: current_customer_retention,
            last_customer_retention: last_customer_retention,
            current_cac: current_cac,
            last_cac: last_cac,
            current_customer_ltv: current_customer_ltv,
            last_customer_ltv: last_customer_ltv,

            // FOR SPARKLINE
            customer_footfalls_spark_graph: customer_footfalls_spark_list,
            customer_conversion_rate_spark_graph: customer_conversion_rate_spark_list,
            customer_number_spark_graph: customer_number_spark_list,
            customer_returning_rate_spark_graph: customer_returning_rate_spark_list,
            customer_frequency_spark_graph: customer_frequency_spark_list,
            customer_basket_size_graph: customer_basket_size_list,
            customer_retention_spark_graph: customer_retention_spark_list,
            customer_cac_spark_graph: customer_cac_spark_list,
            customer_ltv_spark_graph: customer_ltv_spark_list,

            is_customer_graph_loaded: true,
            is_customer_metrices_loaded: true,
          });
        },
        (error) => { }
      );
  }

  handleCallback = (childData) => {

    this.state.first_start_date = childData[0];
    this.state.first_end_date = childData[1];
    this.state.second_start_date = childData[2];
    this.state.second_end_date = childData[3];

    this.state.is_India_map_loaded = false;
    this.getMapdetails();
    this.handleCallback2();
    this.PageFunctionCall();
    this.forceUpdate();
  };

  handleCallback2 = () => {
    this.setState({ isDatePickerOpen: !this.state.isDatePickerOpen });
  };

  handleScroll = () => {
    if (window.pageYOffset > 1) {
      if (!this.state.is_scroll) {
        this.setState({ is_scroll: true });
      }
    } else {
      if (this.state.is_scroll) {
        this.setState({ is_scroll: false });
      }
    }
  };

  handleMapCallback = (childData) => {
    this.forceUpdate();

  };

  handleRiMapFilterCallback = (childData) => {

    let storeCategory = [];
    let storeType = [];
    let storeSize = [];

    // Object.keys(childData[0]).forEach(key => {
    //   if (childData[0][key] == true) {
    //     storeCategory.push(key);
    //   }
    // });
    // Object.keys(childData[1]).forEach(key => {
    //   if (childData[1][key] == true) {
    //     storeType.push(key);
    //   }
    // });

    storeCategory.push(childData[0]);
    storeType.push(childData[1]);
    storeSize.push(childData[2]);

    this.state.map_store_category = storeCategory;
    this.state.map_store_type = storeType;
    this.state.map_store_size = storeSize;

    //0 zone level
    //get city
    if (this.state.map_level == 0) {
      this.state.is_India_map_loaded = false;
      this.getMapdetails();
    }

    //1 city level
    else if (this.state.map_level == 1) {
      this.state.is_India_map_loaded = false;
      this.getIndiaMapCityDetails();
    }

    //2 store level
    else if (this.state.map_level == 2) {
      this.state.is_India_map_loaded = false;
      this.getIndiaMapStoresDetails();
    }

    //3 store code level data 
    else if (this.state.map_level == 3) {
    }


    this.PageFunctionCall();
    this.state.map_filter_storesize_list = childData[3];
    this.forceUpdate();

  };

  handleRISalesSummaryIndiaMapCallBack = (childData) => {

    this.state.North_point = childData[0];
    this.state.South_point = childData[1];
    this.state.center_point = childData[2];
    this.state.map_zone = childData[3];
    this.state.map_city = childData[4];
    this.state.map_store_code = childData[5];
    this.state.map_store_name = childData[6];


    //0 zone level
    //get city
    if (this.state.map_level == 0) {
      this.state.is_India_map_loaded = false;
      this.getIndiaMapCityDetails();
      this.state.mapBreadcrumbList = ['All ZONES', this.state.map_zone];
    }

    //1 city level
    else if (this.state.map_level == 1) {
      this.state.is_India_map_loaded = false;
      this.getIndiaMapStoresDetails();
      this.state.mapBreadcrumbList = ['All ZONES', this.state.map_zone, this.state.map_city];
    }

    //2 store level
    else if (this.state.map_level == 2) {
      this.state.mapBreadcrumbList = ['All ZONES', this.state.map_zone, this.state.map_city, this.state.map_store_name];
      // this.getIndiaMapStoresDetails();
    }
    //3 store code level data 
    else if (this.state.map_level == 3) {
      this.state.mapBreadcrumbList = ['All ZONES', this.state.map_zone, this.state.map_city, this.state.map_store_name];
      // this.getIndiaMapStoresDetails();
    }

    this.state.mapBreadcrumbsCenterPoint = this.state.center_point;
    this.state.mapBreadcrumbsNorthPoint = this.state.North_point;
    this.state.mapBreadcrumbsSouthPoint = this.state.South_point;


    this.PageFunctionCall();
    this.forceUpdate();
  };

  mapBreadcrumbs = (evt, index) => {
    this.state.mapBreadcrumbList.splice(index);

    // level 0
    // all zone
    if (index == 1) {
      this.state.map_zone = '';
      this.state.map_city = '';
      this.state.map_store_code = '';
      this.state.map_store_name = '';
      this.state.map_store_category = '';
      this.state.map_store_type = '';
      this.state.map_store_size = '';
      this.state.map_level = 0;
      this.state.center_point = [0, 0];
      this.state.North_point = [72.6416015625, 37.71859032558816];
      this.state.South_point = [93.1640625, 5.7908968128719565];
      this.state.is_India_map_loaded = false;

      this.getMapdetails();
      this.forceUpdate();
    }
    // level 1
    //city level
    if (index == 2) {
      // this.state.map_zone = '';
      this.state.map_city = '';
      this.state.map_store_code = '';
      this.state.map_store_name = '';
      this.state.map_level = 0;
      this.state.center_point = [0, 0];
      this.state.North_point = [72.6416015625, 37.71859032558816];
      this.state.South_point = [93.1640625, 5.7908968128719565];
      this.state.is_India_map_loaded = false;

      this.getIndiaMapCityDetails();
      this.forceUpdate();
    }
    // level 3
    //Store level
    if (index == 3) {
      // this.state.map_zone = '';
      //this.state.map_city = '';
      this.state.map_store_code = '';
      this.state.map_store_name = '';
      this.state.map_level = 0;
      this.state.center_point = [0, 0];
      this.state.North_point = [72.6416015625, 37.71859032558816];
      this.state.South_point = [93.1640625, 5.7908968128719565];
      this.state.is_India_map_loaded = false;

      this.getIndiaMapStoresDetails();
      this.forceUpdate();
    }

    this.PageFunctionCall();
    this.forceUpdate();


  }


  // STORE DEEP DIVES
  shandleCallback = (childData) => {
    this.state.footfalls_dropdown_value = childData;
    this.setState({ is_store_deep_bubble_chart_loaded: false });
    this.getStoreDeepDriveBubbleChart();
  };
  // STORE DEEP DIVES
  dhandleCallback = (childData) => {
    this.state.nsv_dropdown_value = childData;
    this.setState({ is_store_deep_bubble_chart_loaded: false });
    this.getStoreDeepDriveBubbleChart();
  };

  // tree DEEP DIVES dropdown
  deepDivehandleCallback = (childData) => {
    this.state.category_dropdown_value = childData;
    this.setState({ is_category_deep_dive_loaded: false });
    this.getCategoryDeepDive();
  };
  //Rupesh Deep Dive code
  handleNSVdeepDiveCallback = (childData) => {
    let DeepDiveBreadCrumb = this.state.Deep_Dive_Name;

    // Restrict to 2 levels
    if (DeepDiveBreadCrumb.length >= 2) {
      alert('Maximum drill-down level (2) reached.');
      return;
    }

    DeepDiveBreadCrumb.push(childData.replace('&', '~andtoreplace~'));
    this.state.Deep_Dive_Name = DeepDiveBreadCrumb;
    this.state.Deep_Dive_level = DeepDiveBreadCrumb.length;

    this.state.is_category_deep_dive_loaded = false;
    this.getCategoryDeepDive();
    this.forceUpdate();
  }

  //Rupesh Deep Dive code
  handleNSVdeepDiveCallback2 = (childData) => {
    let DeepDiveBreadCrumb = this.state.Deep_Dive_Name;
    var removed = DeepDiveBreadCrumb.splice(childData);
    this.state.Deep_Dive_Name = DeepDiveBreadCrumb;
    this.state.Deep_Dive_level = DeepDiveBreadCrumb.length;

    if (DeepDiveBreadCrumb.length <= 9) {
      this.state.is_category_deep_dive_loaded = false;

      this.getCategoryDeepDive();
      this.forceUpdate();
    } else {
      alert('Maximum level reached');
    }
  }

  onClickRiExport = () => {
    window.print('height=2000,width=2000')
  }

  setSelectedSubNav = (tab) => {
    this.setState({ selectedSubNav: tab });
  }

  // BRAND DROPDOWN
  brandDropdownSelectionHandler = (e) => {
    if (e === null) {
      this.state.selectedBrandDropdownOption = "";
    } else {
      this.state.selectedBrandDropdownOption = e;
    }
    this.forceUpdate();
  };

  render() {
    const CarouselSettings = {
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        }
      ]
    }
    const now = 40;
    const progress1 = 25; const progress2 = 65; const progress3 = 10;

    // MATRIX_TITLE_BASKET_SIZE already defined above
    // Matrix card titles as variables
    const MATRIX_TITLE_NSV = "New Savings Account";
    const MATRIX_TITLE_UNITS_SOLD = "New Current Accounts";
    const MATRIX_TITLE_BILLS = "New Loans Customers";

    const MATRIX_TITLE_NET_MARGIN = "Total Loan's Disbursed";
    const MATRIX_TITLE_ATS = " Credit Card Customers";
    const MATRIX_TITLE_SELL_THROUGH = " Fixed Deposits";
    const MATRIX_TITLE_ASP = "Demat Accounts";
    const MATRIX_TITLE_MARKDOWN = "Daily Transaction Count";
    const MATRIX_TITLE_RGM = "RGM";
    const MATRIX_TITLE_BASKET_SIZE = "Avg. Sales per Branch";

    const MATRIX_TITLE_TOTAL_CUSTOMERS = "Total Customers";
    const MATRIX_TITLE_NEW_CUSTOMER_ACQUISITIONS = "New Customer Acquisitions";
    const MATRIX_TITLE_CUSTOMERS_LOST = "Customers Lost";
    const MATRIX_TITLE_AVG_PRODUCTS_PER_CUSTOMER = "Avg. Products per Customer";
    const MATRIX_TITLE_CSAT = "CSAT";
    const MATRIX_TITLE_CUSTOMER_RETENTION = "Customer Retention";
    const MATRIX_TITLE_CAC = "CAC";
    const MATRIX_TITLE_CUSTOMER_LTV = "Customer LTV";
    const MATRIX_TITLE_CONVERSION_RATE = "Conversion Rate";


    // Define card titles as variables for maintainability
    const CARD_TITLE_NSV = "New Savings Account";
    const CARD_TITLE_FOOTFALLS = "Total Customers";
    const CARD_TITLE_BILLS = "New Loans Customers";
    const CARD_TITLE_ATS = " Credit Card Customers";
    const CARD_TITLE_NET_MARGIN = "Total Loan's Disbursed";
    const CARD_TITLE_BASKET_SIZE = "Avg. Sales per Branch";

    return (
      <Wrapper>
        <div className="grid drawer_grid ri_summary_bsImport">
          <div className="left_drawer col_span_1 fixed-left-grid mapRightWrapper" id="india_map">
            <div className="icz-rimapsection">
              {this.state.is_India_map_loaded == true ?
                <Wrapper>
                  <Col lg={12} className="icz-rimapsectionheader">
                    <Wrapper>
                      <Wrapper>
                        <Col lg={4} md={4} sm={12} className="icz-rimaptitle">
                          {this.state.country != null ? (this.state.country.toUpperCase() == "UK" ? "UK" : this.state.country.toUpperCase() == "US" ? "US" : "India") : "India"}
                        </Col>
                        <Col lg={8} md={8} sm={12} className="icz-rimapfilter">
                          <RiMapFilter
                            parentCallback={this.handleRiMapFilterCallback}
                            map_filter_category_list={this.state.map_filter_category_list}
                            map_filter_storetype_list={this.state.map_filter_storetype_list}
                            map_filter_storesize_list={this.state.map_filter_storesize_list} />

                          <div className="icz-ribtnwrapper">
                            <button className="icz-rithemebtn">
                              <IconDownload className="icz-riicon" /> </button>
                          </div>
                        </Col>
                      </Wrapper>
                      <div className="breadcrumb-no-padding">
                        <Breadcrumb>
                          {this.state.mapBreadcrumbList.map((item, index) => (
                            <Breadcrumb.Item onClick={() => { this.mapBreadcrumbs(item, index + 1) }} key={index}>{item}</Breadcrumb.Item>
                          ))}
                        </Breadcrumb>
                      </div>
                    </Wrapper>
                  </Col>

                  <Col lg={12} className="icz-rimapcontainer">
                    {/* {this.state.is_India_map_loaded == true ?
                      <IndiaMap 
                        data={this.state.MapMarker}
                        parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                        North_point={this.state.North_point}
                        South_point={this.state.South_point}
                        Center_point={this.state.center_point}
                        map_level={this.state.map_level}
                        rangetype={this.state.rangetype}
                      />
                      : <Loader />} */}
                    {this.state.is_India_map_loaded == true ?
                      <>
                        {(() => {
                          switch (this.state.country) {
                            case "india": return <IndiaMap data={this.state.MapMarker}
                              parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                              North_point={this.state.North_point}
                              South_point={this.state.South_point}
                              Center_point={this.state.center_point}
                              map_level={this.state.map_level}
                              rangetype={this.state.rangetype}
                              ref={this.printRef}
                            />;
                            case "UK": return <UKMap
                              data={this.state.MapMarker}
                              parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                              North_point={this.state.North_point}
                              South_point={this.state.South_point}
                              Center_point={this.state.center_point}
                              map_level={this.state.map_level}
                              rangetype={this.state.rangetype}
                              ref={this.printRef}
                            ></UKMap>;
                            case "US": return <USMap
                              data={this.state.MapMarker}
                              parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                              North_point={this.state.North_point}
                              South_point={this.state.South_point}
                              Center_point={this.state.center_point}
                              map_level={this.state.map_level}
                              rangetype={this.state.rangetype}
                              ref={this.printRef}
                            ></USMap>;
                            default: return <IndiaMap data={this.state.MapMarker}
                              parentCallback={this.handleRISalesSummaryIndiaMapCallBack}
                              North_point={this.state.North_point}
                              South_point={this.state.South_point}
                              Center_point={this.state.center_point}
                              map_level={this.state.map_level}
                              rangetype={this.state.rangetype}
                              ref={this.printRef}
                            />;
                          }
                        })()}
                      </>
                      : <Loader />}
                  </Col>

                  <div className="icz-rimapfooter">
                    <Col lg={12}>
                      <ul className="icz-rilist-inline">
                        <li><div className="icz-rilist-bullet1" /> North</li>
                        <li><div className="icz-rilist-bullet2" /> West</li>
                        <li><div className="icz-rilist-bullet3" /> South</li>
                        <li><div className="icz-rilist-bullet4" /> East</li>
                        <li><div className="icz-rilist-bullet5" /> APTS</li>
                      </ul>
                    </Col>

                    <Col lg={12} className="icz-rimapprogressbar">
                      <h4 className="icz-riprogresstitle">Branch Scrore Range</h4>
                      <ProgressBar>
                        <ProgressBar className="range1" variant="range1" now={progress1} key={1} label="0-30" />
                        <ProgressBar className="range2" variant="range2" now={progress2} key={2} label="31-70" />
                        <ProgressBar className="range3" variant="range3" now={progress3} key={3} label="71+" />
                      </ProgressBar>
                    </Col>
                  </div>
                </Wrapper>
                : <Loader />}
            </div>
          </div>
          <div className="right_side col_span_3 relative-right-grid icz-ridatacontainer" style={{ padding: "0" }}>
            <div className="content">
              <div className="content_section">
                <PageHeader pageTitle={"Branch Score"} />
                <div className="grid grid_cols_1 page_content">
                  <div className="dashboard_home">

                    <div className="grid grid_cols_1 grid_margin_bottom">
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader">
                            <Col lg={10} className="icz-cardtitle">
                              Branch Score
                            </Col>
                            <Col lg={2} className="icz-cardfilter">
                              <div className="icz-cardbtnwrapper">
                                <ChartExport ChartId='business_score' exportName="Branch Score"
                                  export_href={this.state.export_href} downloadName="Branch-Score.csv"
                                  export_data={this.state.storehealth_businessNew}
                                />
                              </div>
                            </Col>
                          </Col>
                          {this.state.is_storehealth_businessscore_loaded == true ?
                            <div className="icz-ridatadetails d-flex">

                              <Col sm={12} lg={3} className="align-items-start">
                                <Col lg={12}>
                                  <div className="icz-riscorecontainer">
                                    <div className="icz-riscorecontainer icz-riscoretitle">
                                      {this.state.storehealth_graph_pointer_business}
                                    </div>
                                  </div>
                                  <SolidGaugeChart
                                    chart_id="business_score"
                                    chart_class="icz-sectionchart icz-ribscorechart"
                                    graph-data={this.state.storehealth_businessNew} />
                                </Col>
                              </Col>

                              <Col sm={12} lg={9} className="d-flex align-items-start icz-risalessection">
                                <Col lg={3} sm={12} className="icz-risalecontainer">
                                  <h4 className="icz-ri-txtblue"> {this.state.storehealth_graph_pointer_sale}</h4>
                                  <SolidGaugeChart chart_id="sale_score" chart_class="icz-sectionsmallchart" graph-data={this.state.storehealth_sale} />
                                  <h5>Revenue</h5>
                                  <div className="icz-risalesdata">Comprises of income from products and services, cost, profit, etc.</div>
                                </Col>
                                <Col lg={3} sm={12} className="icz-risalecontainer">
                                  <h4 className="icz-ri-txtblue">{this.state.storehealth_graph_pointer_customer}</h4>
                                  <SolidGaugeChart chart_id="customer_score" chart_class="icz-sectionsmallchart" graph-data={this.state.storehealth_customer} />
                                  <h5>Customer Attributes</h5>
                                  <div className="icz-risalesdata">Comprises of customer satisfaction, number of new customers, Cross Sell%, Up Selling% etc.</div>
                                </Col>
                                <Col lg={3} sm={12} className="icz-risalecontainer">
                                  <h4 className="icz-ri-txtblue"> {this.state.storehealth_graph_pointer_presence}</h4>
                                  <SolidGaugeChart chart_id="presence_score" chart_class="icz-sectionsmallchart" graph-data={this.state.storehealth_presence} />
                                  <h5>Branch Presence</h5>
                                  <div className="icz-risalesdata">Comprises of Branch rating, Competition, Market Share of Branch in the area etc.</div>
                                </Col>
                                <Col lg={3} sm={12} className="icz-risalecontainer">
                                  <h4 className="icz-ri-txtblue"> {this.state.storehealth_graph_pointer_category}</h4>
                                  <SolidGaugeChart chart_id="category_score" chart_class="icz-sectionsmallchart" graph-data={this.state.storehealth_category} />
                                  <h5>Product Performance</h5>
                                  <div className="icz-risalesdata">Comprises of Product Sales, Product Growth, Product Mix etc.</div>
                                </Col>
                              </Col>
                            </div>
                            : <Loader />
                          }
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1">
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader">
                            <Col className="icz-cardtitle">
                              Branch Trend
                            </Col>
                          </Col>
                          <div className="icz-carouselcontainer">
                            {this.state.is_businessscoreTrend_loaded == true && this.state.is_businessscoreTrend_loaded ?
                              <Carousel
                                Settings={CarouselSettings}
                                class={"icz-cardcontainer"}
                                SliderCards={[
                                  <ScoreCard
                                    index="1"
                                    CardClass="icz-riscorecardwrapper icz-ricardborder"
                                    CardTitle="Overall"
                                    CardScoreTitle="53"
                                    CardScoreSubTitle="High"
                                    CardWeekTitle="Wk 42"
                                    CardScoreTitle2="56"
                                    CardScoreSubTitle2="Low"
                                    CardWeekTitle2="Wk 37"
                                    chart={
                                      <Linegraph_sparkline card_id="icz-overall"
                                        card_class="icz-ricardchart"
                                        graph-data={this.state.linesparkgraph_overall_StoreHealth} />}
                                  />,
                                  <ScoreCard
                                    index="2"
                                    CardClass="icz-riscorecardwrapper icz-ricardborder"
                                    CardTitle="Revenue"
                                    CardScoreTitle="53"
                                    CardScoreSubTitle="High"
                                    CardWeekTitle="Wk 42"
                                    CardScoreTitle2="56"
                                    CardScoreSubTitle2="Low"
                                    CardWeekTitle2="Wk 37"
                                    chart={
                                      <Linegraph_sparkline card_id="icz-sale"
                                        card_class="icz-ricardchart"
                                        graph-data={this.state.linesparkgraph_sales_StoreHealth} />}
                                  />,
                                  <ScoreCard
                                    index="3"
                                    CardClass="icz-riscorecardwrapper icz-ricardborder"
                                    CardTitle="Customer Attributes"
                                    CardScoreTitle="53"
                                    CardScoreSubTitle="High"
                                    CardWeekTitle="Wk 42"
                                    CardScoreTitle2="56"
                                    CardScoreSubTitle2="Low"
                                    CardWeekTitle2="Wk 37"
                                    chart={
                                      <Linegraph_sparkline card_id="icz-customer"
                                        card_class="icz-ricardchart"
                                        graph-data={this.state.linesparkgraph_customer_StoreHealth} />}
                                  />,
                                  <ScoreCard
                                    index="4"
                                    CardClass="icz-riscorecardwrapper icz-ricardborder"
                                    CardTitle="Branch Presence"
                                    CardScoreTitle="53"
                                    CardScoreSubTitle="High"
                                    CardWeekTitle="Wk 42"
                                    CardScoreTitle2="56"
                                    CardScoreSubTitle2="Low"
                                    CardWeekTitle2="Wk 37"
                                    chart={
                                      <Linegraph_sparkline card_id="icz-presence"
                                        card_class="icz-ricardchart"
                                        graph-data={this.state.linesparkgraph_presence_StoreHealth} />}
                                  />,
                                  <ScoreCard
                                    index="5"
                                    CardClass="icz-riscorecardwrapper"
                                    CardTitle="Product Performance"
                                    CardScoreTitle="53"
                                    CardScoreSubTitle="High"
                                    CardWeekTitle="Wk 42"
                                    CardScoreTitle2="56"
                                    CardScoreSubTitle2="Low"
                                    CardWeekTitle2="Wk 37"
                                    chart={
                                      <Linegraph_sparkline card_id="icz-category"
                                        card_class="icz-ricardchart"
                                        graph-data={this.state.linesparkgraph_category_StoreHealth} />}
                                  />
                                ]}>

                              </Carousel>
                              :
                              <Loader />
                            }
                          </div>
                        </div>
                      </div>
                    </div>








                    <div className="grid grid_cols_1">
                      <div className="icz-sectioncardwrapper w-100">
                        {this.state.is_storedetails_loaded == true && this.state.is_storedetails_loaded ?
                          <div className="icz-sectioncard d-flex">
                            <div className="icz-ristoredetails">
                              <div><IconSmiley /></div>
                              <div className="icz-ristoredetailsrow">
                                <h3 className="icz-ristoredetailstitle">{this.state.storehealth_storeScoreRank}</h3>
                                <p className="icz-ristoredetailsubtitle">Branch Score Rank</p>
                              </div>
                            </div>

                            <div className="icz-ristoredetails">
                              <div><IconSmiley /></div>
                              <div className="icz-ristoredetailsrow">
                                <h3 className="icz-ristoredetailstitle">{this.state.storehealth_StoreCode}</h3>
                                <p className="icz-ristoredetailsubtitle">Branch Code</p>
                              </div>
                            </div>

                            <div className="icz-ristoredetails">
                              <div><IconSmiley /></div>
                              <div className="icz-ristoredetailsrow">
                                <h3 className="icz-ristoredetailstitle">{this.state.storehealth_StoreManager}</h3>
                                <p className="icz-ristoredetailsubtitle">Branch Manager</p>
                              </div>
                            </div>

                            <div className="icz-ristoredetails">
                              <div><IconSmiley /></div>
                              <div className="icz-ristoredetailsrow">
                                <h3 className="icz-ristoredetailstitle">{this.state.storehealth_StoreOpeningDate}</h3>
                                <p className="icz-ristoredetailsubtitle">Branch Opening Date</p>
                              </div>
                            </div>

                            <div className="icz-ristoredetails">
                              <div><IconSmiley /></div>
                              <div className="icz-ristoredetailsrow">
                                <h3 className="icz-ristoredetailstitle">{this.state.storehealth_StoreCarpetArea} sq.ft.</h3>
                                <p className="icz-ristoredetailsubtitle">Carpet Area</p>
                              </div>
                            </div>
                          </div>
                          :
                          ''
                        }
                      </div>
                    </div>

                    <div className="grid grid_cols_1 icz-datacontainer">
                      <div className="icz-sectiontabscontainer">
                        <div className="icz-tabscontrols">
                          <TabNav tabs={['Revenue', 'Customer', 'Presence', 'Category']} icon={[<IconTag className="icz-tabicon" />, <IconUserGroup className="icz-tabicon" />, <IconStore className="icz-tabicon" />, <IconWebsite className="icz-tabicon" />]} selected={this.state.selectedSubNav} setSelected={this.setSelectedSubNav}>
                            <Tab isSelected={this.state.selectedSubNav === 'Revenue'}>
                              {this.state.is_StoreScoreStoreSale_parameters_loaded == true ?
                                <StoreSale
                                  store_sale_data={this.state.store_sale_data}
                                />
                                : ''
                              }
                            </Tab>
                            <Tab isSelected={this.state.selectedSubNav === 'Customer'}>
                              {this.state.is_StoreScoreStoreCustomer_parameters_loaded == true ?
                                <StoreCustomer
                                  StoreCustomer_data={this.state.StoreCustomer_data} />
                                : ''
                              }
                            </Tab>
                            <Tab isSelected={this.state.selectedSubNav === 'Presence'}>
                              {this.state.is_StoreScoreStorePresence_parameters_loaded == true ?
                                <StorePresence
                                  max_carpet_area={this.state.storepresence_max_carpet_area}
                                  avg_carpet_area={this.state.storepresence_avg_carpet_area}
                                  min_carpet_area={this.state.storepresence_min_carpet_area} />
                                : ''
                              }
                            </Tab>
                            <Tab isSelected={this.state.selectedSubNav === 'Category'}>
                              {this.state.is_StoreScoreCategory_parameters_loaded == true ?
                                <StoreCategory
                                  storehealth_StoreCategory={this.state.storehealth_StoreCategory} />
                                : ''
                              }
                            </Tab>
                          </TabNav>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1">
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader">
                            <Col lg={10} className="icz-cardtitle">
                              Branch Performance Overview
                            </Col>
                            <Col lg={2} className="icz-cardfilter">
                              <div className="icz-cardbtnwrapper">
                                <ChartExport ChartId='top_bottom_stores' exportName="Branch Performance Overview"
                                  export_href={this.state.export_href} downloadName="Branch-Performance-Overview.csv"
                                  export_data={this.state.topstoredata}
                                />
                              </div>
                            </Col>
                          </Col>
                          {this.state.is_StoreScoreOverview_parameters_loaded == true ?
                            <div className="d-flex" id="top_bottom_stores">
                              <Col sm={12} lg={6} className="align-items-start icz-cardsectiondevider icz-cardpadding">
                                <RiSalesVBarChart chart_id="top_stores" chart_class="icz-sectionchart" Ytitle={""} metric_1={"Top Branches by Score"} graph-data={this.state.topstoredata} bar_color={"#11a1fd"} />
                              </Col>
                              <Col sm={12} lg={6} className="icz-cardpadding">
                                <RiSalesVBarChart chart_id="bottom_stores" chart_class="icz-sectionchart" Ytitle={""} metric_1={"Bottom Branches by Score"} graph-data={this.state.bottomstoredata} bar_color={"#FF9931"} />
                              </Col>
                            </div>
                            : <Loader />}
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1 w-300">
                      {this.state.is_StoreTopBottomMover_parameters_loaded == true ?
                        <RiTopMoversTab
                          Top5Movers={this.state.Top5Movers}
                          Bottom5Movers={this.state.Bottom5Movers} />
                        : <Loader />}
                    </div>

                    <div className="grid grid_cols_4">
                      <div className="grid col_span_4 icz-ricardheader">
                        <div className="icz-ricardtitle">
                          Branch Parameters
                        </div>

                      </div>
                      <div className="grid col_span_4 icz-carouselcontainer">
                        {this.state.is_sales_metrices_loaded == true && this.state.is_sales_graph_loaded == true ?
                          <Carousel
                            Settings={CarouselSettings}
                            class={"icz-cardcontainer"}
                            SliderCards={[
                              <SummaryCard
                                index="1"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_NSV}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.current_nsv}
                                    progress={(this.state.current_nsv / (this.state.current_nsv * 1.8)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={parseFloat(this.state.current_nsv).toFixed(2)}
                                IsStandard={true}
                                RowOnePreviousValue={parseFloat(this.state.last_nsv).toFixed(2)}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-nsv"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_nsv_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              <SummaryCard
                                index="6"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_UNITS_SOLD}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.current_units_sold}
                                    progress={(this.state.current_units_sold / (this.state.current_units_sold * 1.2)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={parseFloat(
                                  this.state.current_units_sold
                                ).toFixed(2)}
                                RowOnePreviousValue={parseFloat(
                                  this.state.last_units_sold
                                ).toFixed(2)}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-units"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_units_sold_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              <SummaryCard
                                index="3"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_BILLS}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.current_target_bills}
                                    progress={(this.state.current_bills / (this.state.current_bills * 1.8)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={this.state.current_bills}
                                RowOnePreviousValue={this.state.last_bills}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-bills"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_bills_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              <SummaryCard
                                index="2"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_NET_MARGIN}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.current_target_net_margin}
                                    progress={(this.state.current_net_margin / (this.state.current_net_margin * 1.8)) * 100}
                                    isnumber={'money'}
                                  />
                                }
                                RowOneCurrentValue={
                                  parseFloat(this.state.current_net_margin).toFixed(2)
                                }
                                RowOnePreviousValue={
                                  parseFloat(this.state.last_net_margin).toFixed(2)
                                }
                                RowOneTitle="overall"
                                IsNumber={'money'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-netmargin"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_net_margin_spark_graph}
                                    isnumber={'decimal_percentage'}
                                  />
                                }
                              />,

                              <SummaryCard
                                index="4"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_ATS}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.current_target_ats}
                                    progress={(this.state.current_average_ticket_size / (this.state.current_average_ticket_size * 1.8)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={parseFloat(
                                  this.state.current_average_ticket_size
                                ).toFixed(2)}
                                RowOnePreviousValue={parseFloat(
                                  this.state.last_average_ticket_size
                                ).toFixed(2)}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-ats"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_ats_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              <SummaryCard
                                index="5"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_SELL_THROUGH}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.current_target_sell_through}
                                    progress={(this.state.current_target_sell_through / (this.state.current_target_sell_through * 1.1)) * 100}
                                    isnumber={'money'}
                                  />
                                }
                                RowOneCurrentValue={this.state.current_target_sell_through}
                                RowOnePreviousValue={
                                  parseFloat(this.state.last_sell_through).toFixed(2)
                                }
                                RowOneTitle="overall"
                                IsNumber={'money'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-sell"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_sell_through_spark_graph}
                                    isnumber={'money'}
                                  />
                                }
                              />,

                              <SummaryCard
                                index="7"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_ASP}
                                progressbar={
                                  <Progressbar
                                    targetHover={parseFloat(this.state.current_target_asp).toFixed(2)}
                                    progress={(this.state.current_average_selling_price / (this.state.current_average_selling_price * 1.1)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={parseFloat(this.state.current_average_selling_price).toFixed(2)}
                                RowOnePreviousValue={parseFloat(
                                  this.state.last_average_selling_price
                                ).toFixed(2)}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-asp"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_asp_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              <SummaryCard
                                index="8"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_MARKDOWN}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.current_target_markdown}
                                    progress={(this.state.current_markdown / (this.state.current_markdown * 1.1)) * 100}
                                    isnumber={'percentage'}
                                  />
                                }
                                RowOneCurrentValue={
                                  parseFloat(this.state.current_markdown).toFixed(2)
                                }
                                RowOnePreviousValue={
                                  parseFloat(this.state.last_markdown).toFixed(2)
                                }
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-markdown"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_markdown_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              // <SummaryCard
                              //     index="9"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle="RGM"
                              //     progressbar={
                              //         <Progressbar
                              //             targetHover={this.state.current_target_rgm}
                              //             progress={this.state.current_target_rgm_achieved}
                              //             isnumber={'money'}
                              //         />
                              //     }
                              //     RowOneCurrentValue={parseFloat(
                              //         this.state.current_rgm
                              //     ).toFixed(2)}
                              //     RowOnePreviousValue={parseFloat(
                              //         this.state.last_rgm
                              //     ).toFixed(2)}
                              //     RowOneTitle="overall"
                              //     IsNumber={'money'}
                              //     chart={
                              //         <Linegraph_sparkline
                              //             card_id="icz-rgm"
                              //             card_class="icz-cardchart"
                              //             graph-data={this.state.sales_rgm_spark_graph}
                              //             isnumber={'money'}
                              //         />
                              //     }
                              // />,
                              <SummaryCard
                                index="10"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_BASKET_SIZE}
                                progressbar={
                                  <Progressbar
                                    targetHover={parseFloat(this.state.current_target_basket_size).toFixed(2)}
                                    progress={(this.state.current_basket_size / (this.state.current_basket_size * 1.01)) * 100}
                                    isnumber={'money'}
                                  />
                                }
                                RowOneCurrentValue={parseFloat(
                                  this.state.current_basket_size
                                ).toFixed(2)}
                                RowOnePreviousValue={parseFloat(
                                  this.state.last_basket_size
                                ).toFixed(2)}
                                RowOneTitle="overall"
                                IsNumber={'money'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="sales_basket_size"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.sales_basket_size_graph}
                                    isnumber={'money'}
                                  />
                                }
                              />,
                              // <ValueCard
                              //     index="11"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle="Recovery%"
                              //     RowOneCurrentValue={parseFloat(this.state.current_recovery).toFixed(2)}
                              //     IsNumber={'percentage'}
                              // />,
                              // <ValueCard
                              //     index="12"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle="PSFPD"
                              //     RowOneCurrentValue={parseFloat(this.state.current_pspfo).toFixed(2)}
                              //     RowOneCurrentValueUnit={'Sales Per sq.ft.'}
                              //     IsNumber={'number'}
                              // />,
                              // <ValueCard
                              //     index="13"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle="MBQ%"
                              //     RowOneCurrentValue={this.state.current_mbq}
                              //     IsNumber={'number'}
                              // />,
                            ]}
                          ></Carousel>
                          : <Loader />}
                      </div>
                    </div>

                    <div className="grid grid_cols_4">
                      <div className="grid col_span_4 icz-ricardheader">
                        <div className="icz-ricardtitle">
                          Other Parameters
                        </div>

                      </div>
                      <div className="grid col_span_4 icz-carouselcontainer">
                        {this.state.is_customer_metrices_loaded == true && this.state.is_customer_graph_loaded == true ?
                          <Carousel
                            Settings={CarouselSettings}
                            class={"icz-cardcontainer"}
                            SliderCards={[
                              // 1. Total Customers
                              <SummaryCard
                                index="1"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_TOTAL_CUSTOMERS}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.last_total_customers}
                                    progress={(this.state.current_total_customers / (this.state.current_total_customers * 1.1)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={this.state.current_total_customers}
                                RowOnePreviousValue={this.state.last_total_customers}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-footfalls"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.customer_footfalls_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              // 2. New Customer Acquisitions
                              <SummaryCard
                                index="2"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_NEW_CUSTOMER_ACQUISITIONS}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.last_new_customer_acquisitions}
                                    progress={(this.state.current_new_customer_acquisitions / (this.state.current_new_customer_acquisitions * 1.2)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={this.state.current_new_customer_acquisitions}
                                RowOnePreviousValue={this.state.last_new_customer_acquisitions}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-newcustomer"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.customer_footfalls_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              // 3. Customers Lost
                              <SummaryCard
                                index="3"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_CUSTOMERS_LOST}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.last_customers_lost}
                                    progress={(this.state.current_new_customer_acquisitions / (this.state.current_new_customer_acquisitions * 1.01)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={this.state.current_customers_lost}
                                RowOnePreviousValue={this.state.last_customers_lost}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-customerslost"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.customer_number_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              // 4. Avg. Products per Customer
                              <SummaryCard
                                index="4"
                                CardClass="icz-cardwrapper"
                                CardIcon={<IconWebsite className="icz-icon" />}
                                CardTitle={MATRIX_TITLE_AVG_PRODUCTS_PER_CUSTOMER}
                                progressbar={
                                  <Progressbar
                                    targetHover={this.state.current_avg_products_per_customer}
                                    progress={(this.state.current_avg_products_per_customer / (this.state.current_avg_products_per_customer * 1.1)) * 100}
                                    isnumber={'number'}
                                  />
                                }
                                RowOneCurrentValue={parseFloat(this.state.current_avg_products_per_customer).toFixed(2)}
                                RowOnePreviousValue={parseFloat(this.state.last_avg_products_per_customer).toFixed(2)}
                                RowOneTitle="overall"
                                IsNumber={'number'}
                                chart={
                                  <Linegraph_sparkline
                                    card_id="icz-avgproducts"
                                    card_class="icz-cardchart"
                                    graph-data={this.state.customer_returning_rate_spark_graph}
                                    isnumber={'number'}
                                  />
                                }
                              />,
                              // 5. Conversion Rate
                              // <SummaryCard
                              //     index="5"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle={MATRIX_TITLE_CONVERSION_RATE}
                              //     progressbar={
                              //         <Progressbar
                              //             targetHover={this.state.last_conversion_rate}
                              //             progress={(this.state.current_conversion_rate / (this.state.current_conversion_rate * 1.3))*100  }  
                              //             isnumber={'percentage'}
                              //         />
                              //     }
                              //     RowOneCurrentValue={parseFloat(this.state.current_conversion_rate).toFixed(2)}
                              //     RowOnePreviousValue={parseFloat(this.state.last_conversion_rate).toFixed(2)}
                              //     RowOneTitle="overall"
                              //     IsNumber={'percentage'}
                              //     chart={
                              //         <Linegraph_sparkline
                              //             card_id="icz-convrate"
                              //             card_class="icz-cardchart"
                              //             graph-data={this.state.customer_conversion_rate_spark_graph}
                              //             isnumber={'decimal_percentage'}
                              //         />
                              //     }
                              // />,
                              // // 6. CSAT
                              // <SummaryCard
                              //     index="6"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle={MATRIX_TITLE_CSAT}
                              //     progressbar={
                              //         <Progressbar
                              //             targetHover={this.state.last_csat}
                              //             progress={(this.state.current_csat / (this.state.current_csat + 10))*100  }  
                              //             isnumber={'number'}
                              //         />
                              //     }
                              //     RowOneCurrentValue={parseFloat(this.state.current_csat).toFixed(2)}
                              //     RowOnePreviousValue={parseFloat(this.state.last_csat).toFixed(2)}
                              //     RowOneTitle="overall"
                              //     IsNumber={'percentage'}
                              //     chart={
                              //         <Linegraph_sparkline
                              //             card_id="icz-csat"
                              //             card_class="icz-cardchart"
                              //             graph-data={this.state.customer_frequency_spark_graph}
                              //             isnumber={'percentage'}
                              //         />
                              //     }
                              // />,
                              // 7. Customer Retention
                              // <SummaryCard
                              //     index="7"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle={MATRIX_TITLE_CUSTOMER_RETENTION}
                              //     progressbar={
                              //         <Progressbar
                              //             targetHover={this.state.last_customer_retention}
                              //             progress={this.state.current_customer_retention}
                              //             isnumber={'number'}
                              //         />
                              //     }
                              //     RowOneCurrentValue={parseFloat(this.state.current_customer_retention).toFixed(2)}
                              //     RowOnePreviousValue={parseFloat(this.state.last_customer_retention).toFixed(2)}
                              //     RowOneTitle="overall"
                              //     IsNumber={'percentage'}
                              //     IsStandard={false}
                              //     chart={
                              //         <Linegraph_sparkline
                              //             card_id="customer-retention"
                              //             card_class="icz-cardchart"
                              //             graph-data={this.state.customer_retention_spark_graph}
                              //             isnumber={'percentage'}
                              //         />
                              //     }
                              // />,
                              // // 8. CAC
                              // <SummaryCard
                              //     index="8"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle={MATRIX_TITLE_CAC}
                              //     progressbar={
                              //         <Progressbar
                              //             targetHover={this.state.last_cac}
                              //             progress={this.state.current_cac}
                              //             isnumber={'number'}
                              //         />
                              //     }
                              //     RowOneCurrentValue={parseFloat(this.state.current_cac).toFixed(2)}
                              //     RowOnePreviousValue={parseFloat(this.state.last_cac).toFixed(2)}
                              //     RowOneTitle="overall"
                              //     IsNumber={'Money'}
                              //     chart={
                              //         <Linegraph_sparkline
                              //             card_id="customer-cac"
                              //             card_class="icz-cardchart"
                              //             graph-data={this.state.customer_cac_spark_graph}
                              //             isnumber={'Money'}
                              //         />
                              //     }
                              // />,
                              // // 9. Customer LTV
                              // <SummaryCard
                              //     index="9"
                              //     CardClass="icz-cardwrapper"
                              //     CardIcon={<IconWebsite className="icz-icon" />}
                              //     CardTitle={MATRIX_TITLE_CUSTOMER_LTV}
                              //     progressbar={
                              //         <Progressbar
                              //             targetHover={this.state.last_customer_ltv}
                              //             progress={this.state.current_customer_ltv}
                              //             isnumber={'number'}
                              //         />
                              //     }
                              //     RowOneCurrentValue={parseFloat(this.state.current_customer_ltv).toFixed(2)}
                              //     RowOnePreviousValue={parseFloat(this.state.last_customer_ltv).toFixed(2)}
                              //     RowOneTitle="overall"
                              //     IsNumber={'number'}
                              //     chart={
                              //         <Linegraph_sparkline
                              //             card_id="customer-ltv"
                              //             card_class="icz-cardchart"
                              //             graph-data={this.state.customer_ltv_spark_graph}
                              //             isnumber={'number'}
                              //         />
                              //     }
                              // />,
                            ]}
                          ></Carousel>
                          :
                          <Loader />}
                      </div>
                    </div>

                    {/* <div className="grid grid_cols_1 grid_margin_bottom">
                      <Col lg={12} className="icz-ricardheader">
                        <Col lg={6} className="icz-ricardtitle">
                          Branch Parameters
                        </Col>
                        <Col lg={6} className="icz-ricardfilter">
                        </Col>
                      </Col>
                    </div>


                    <div className="grid col_span_1 grid_margin_bottom icz-carouselcontainer">
                      {this.state.is_store_parameters_loaded == true ?
                        <Carousel
                          Settings={CarouselSettings}
                          class={"icz-cardcontainer"}
                          SliderCards={[
                            <SummaryCard
                              index="1"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle={CARD_TITLE_NSV}
                              progressbar={
                                <Progressbar
                                  targetHover={this.state.tooltip_nsv_target}
                                  progress={this.state.tooltip_nsv_achieved}
                                  isnumber={'money'}
                                />
                              }
                              RowOneCurrentValue={parseFloat(this.state.current_target_nsv).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_target_nsv_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'money'}
                              chart={<Linegraph_sparkline
                                card_id="icz-nsv"
                                card_class="icz-cardchart"
                                graph-data={this.state.spark_list_nsv} isnumber={'money'} />}
                            />,
                            <SummaryCard
                              index="2"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle={CARD_TITLE_FOOTFALLS}
                              progressbar={
                                <Progressbar
                                  targetHover={this.state.tooltip_footfalls_target}
                                  progress={this.state.tooltip_footfalls_achieved}
                                  isnumber={'money'}
                                />
                              }
                              RowOneCurrentValue={this.state.current_target_footfalls}
                              RowOnePreviousValue={this.state.current_footfalls_achieved}
                              RowOneTitle="overall"
                              IsNumber={'number'}
                              chart={<Linegraph_sparkline
                                card_id="icz-footfalls"
                                card_class="icz-cardchart"
                                graph-data={this.state.spark_list_footfall} />}
                            />,
                            <SummaryCard
                              index="3"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle={CARD_TITLE_BILLS}
                              progressbar={
                                <Progressbar
                                  targetHover={this.state.tooltip_bills_target}
                                  progress={this.state.tooltip_bills_achieved}
                                  isnumber={'money'}
                                />
                              }
                              RowOneCurrentValue={parseFloat(this.state.current_target_bills).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_target_bills_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'money'}
                              chart={<Linegraph_sparkline
                                card_id="icz-bills" card_class="icz-cardchart"
                                graph-data={this.state.spark_list_bills} />}
                            />,
                            <SummaryCard
                              index="4"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle={CARD_TITLE_ATS}
                              progressbar={
                                <Progressbar
                                  targetHover={this.state.tooltip_ats_target}
                                  progress={this.state.tooltip_ats_achieved}
                                  isnumber={'money'}
                                />
                              }
                              RowOneCurrentValue={parseFloat(this.state.current_target_ats).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_target_ats_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'money'}
                              chart={<Linegraph_sparkline
                                card_id="icz-ats" card_class="icz-cardchart"
                                graph-data={this.state.spark_list_ats} />}
                            />,
                            <SummaryCard
                              index="5"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle={CARD_TITLE_NET_MARGIN}
                              progressbar={
                                <Progressbar
                                  targetHover={this.state.tooltip_net_margin_target}
                                  progress={this.state.tooltip_net_margin_achieved}
                                  isnumber={'percentage'}
                                />
                              }
                              RowOneCurrentValue={parseFloat(this.state.current_target_net_margin).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_target_net_margin_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'percentage'}
                              chart={<Linegraph_sparkline
                                card_id="icz-netmargin" card_class="icz-cardchart"
                                graph-data={this.state.spark_list_net_margin}
                                isnumber={'decimal_percentage'} />}
                            />,
                            <SummaryCard
                              index="6"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle={CARD_TITLE_BASKET_SIZE}
                              progressbar={
                                <Progressbar
                                  targetHover={this.state.tooltip_basket_size_target}
                                  progress={this.state.tooltip_basket_size_achieved}
                                  isnumber={'money'}
                                />
                              }
                              RowOneCurrentValue={parseFloat(this.state.current_current_basket_size).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_current_basket_size_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'money'}
                              chart={<Linegraph_sparkline
                                card_id="icz-basketsz" card_class="icz-cardchart"
                                graph-data={this.state.spark_list_basket_size} />}
                            />
                          ]}>

                        </Carousel>
                        : <Loader />}
                    </div>

                    <div className="grid grid_cols_1 grid_margin_bottom">
                      <Col lg={12} className="icz-ricardheader">
                        <Col lg={6} className="icz-ricardtitle">
                          Other Parameters
                        </Col>
                        <Col lg={6} className="icz-ricardfilter">

                        </Col>
                      </Col>
                    </div>
                     
                    <div className="grid col_span_1 grid_margin_bottom icz-carouselcontainer">
                      {this.state.is_store_parameters_loaded == true ?
                        <Carousel
                          Settings={CarouselSettings}
                          class={"icz-cardcontainer"}
                          SliderCards={[
                            <ChartCard
                              index="1"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle="Units"
                              RowOneCurrentValue={parseFloat(this.state.current_target_units_sold).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_target_units_sold_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'number'}
                              chart={<Linegraph_sparkline
                                card_id="icz-units"
                                card_class="icz-cardchart"
                                graph-data={this.state.spark_list_units} />}
                            />,
                            <ChartCard
                              index="2"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle="Sell Through%"
                              RowOneCurrentValue={parseFloat(this.state.current_target_sell_through).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_target_sell_through_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'percentage'}
                              chart={
                                <Linegraph_sparkline
                                  card_id="icz-sellthrough"
                                  card_class="icz-cardchart" graph-data={this.state.spark_list_sell_through}
                                  isnumber={'percentage'} />}
                            />,
                            <ChartCard
                              index="3"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle="Conversion Rate%"
                              RowOneCurrentValue={parseFloat(this.state.current_target_conversion_rate).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_conversion_rate_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'percentage'}
                              chart={<Linegraph_sparkline card_id="icz-convrate"
                                card_class="icz-cardchart" graph-data={this.state.spark_list_conversion_rate}
                                isnumber={'decimal_percentage'} />}
                            />,
                            <ChartCard
                              index="4"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle="Customer Repeat rate %"
                              RowOneCurrentValue={parseFloat(this.state.current_target_returning_rate).toFixed(2)}
                              RowOnePreviousValue={parseFloat(this.state.current_returning_rate_achieved).toFixed(2)}
                              RowOneTitle="overall"
                              IsNumber={'percentage'}
                              chart={<Linegraph_sparkline card_id="icz-custrate"
                                card_class="icz-cardchart"
                                graph-data={this.state.spark_list_customer_returining_rate} isnumber={'decimal_percentage'} />}
                            />,
                            <ChartCard
                              index="5"
                              CardClass="icz-cardwrapper"
                              CardIcon={<IconWebsite className="icz-icon" />}
                              CardTitle="Recovery%"
                              RowOneCurrentValue={parseFloat(this.state.current_target_recovery).toFixed(2)}
                              IsNumber={'percentage'}
                            />
                          ]}>

                        </Carousel>
                        : <Loader />}
                    </div>
*/}
                    <div className="grid grid_cols_1 grid_margin_bottom">
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col lg={12} className="icz-cardheader  flex-wrap">
                            <Col className="icz-cardtitle">
                              Branch Performance

                            </Col>
                            <Col className="icz-cardfilter flex-row flex-nowrap">
                              {/* <Dropdown
                                dropdown_options={this.state.footfalls_dropdown_options}
                                dropdown_placeholder=""
                                parentCallback={this.shandleCallback}
                              />
                              <Dropdown
                                dropdown_options={this.state.nsv_dropdown_options}
                                dropdown_placeholder=""
                                parentCallback={this.dhandleCallback} /> */}
                              <ChartExport ChartId='store-data' exportName="Business Overview"
                                export_href={this.state.export_href} downloadName="Business-Overview.csv"
                                export_data={this.state.storehealth_storedata}
                              />
                            </Col>
                          </Col>
                          <div className="">
                            {this.state.is_store_deep_bubble_chart_loaded == true ?
                              <RiStoreBubbleChart
                                chart_id="store-data"
                                chart_class="icz-sectionchart"
                                Xtitle={this.state.nsv_dropdown_value}
                                Ytitle={this.state.footfalls_dropdown_value}
                                metric_1={"Mature Store"}
                                metric_2={"New Store"}
                                metric_3={"LTL Store"}
                                isnumber={"money"}
                                graph-data={this.state.storehealth_storedata} />
                              : <Loader />}
                          </div>
                          <div className="">
                            <Col lg={12} className="d-flex">
                              <Col lg={6} className="icz-ridatabullet">
                                <ul className="icz-ridatalist-inline">
                                  <li><div className="icz-ridatalist-bullet5" /> High Branch Performance Score</li>
                                  <li><div className="icz-ridatalist-bullet2" /> Med Branch Performance Score</li>
                                  <li><div className="icz-ridatalist-bullet6" /> Low Branch Performance Score</li>
                                </ul>
                              </Col>
                              <Col lg={6} className="icz-ridatabullet">
                                <ul className="icz-ridatalist-inline">
                                  <li><div className="icz-ridatalist-bullet7" />  New Branch</li>
                                  <li><div className="icz-ridatalist-bullet8" /> Mature Store</li>
                                  <li><div className="icz-ridatalist-bullet9" />Like-to-Like Branch</li>
                                </ul>
                              </Col>

                            </Col>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid_cols_1 grid_margin_bottom">
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader flex-wrap">
                            <Col lg={8} md={4} sm={12} className="icz-cardtitle">
                              Product Assortment
                            </Col>
                            <Col lg={4} md={8} sm={12} className="icz-cardfilter flex-row flex-wrap ">
                              {/* <Dropdown
                          dropdown_options={this.state.category_dropdown_options}
                          dropdown_placeholder="NSV"
                          parentCallback={this.deepDivehandleCallback} /> */}
                              <div className="icz-cardbtnwrapper">
                                <ChartExport ChartId='icz-treemap' exportName="Product Assortment"
                                  export_href={this.state.export_href} downloadName="Product Assortment.csv"
                                  export_data={this.state.Store_health_category_deep_dive_graph}
                                />
                              </div>
                            </Col>
                          </Col>
                          {this.state.is_category_deep_dive_loaded == true ?
                            <>
                              <div className="w-100">
                                <RiTreegraph card_id="icz-treemap" card_class="icz-sectionchart"
                                  graph-data={this.state.Store_health_category_deep_dive_graph}
                                  parentCallback={this.handleNSVdeepDiveCallback}
                                  Level_Counter={this.state.Deep_Dive_level}
                                  parentCallback2={this.handleNSVdeepDiveCallback2}
                                  Deep_Dive_BreadCrumb={this.state.Deep_Dive_Name}
                                  dropdownValue={this.state.category_dropdown_value}
                                  isnumber={'money'} />
                              </div>
                              <div className="w-100">
                                <Col lg={12} className="icz-ridatabullet">
                                  <ul className="icz-ridatalist-inline">
                                    <li>Area = Sales</li>
                                    <li><div className="icz-ridatalist-bullet5" /> High Target Achieved %
                                    </li>
                                    <li><div className="icz-ridatalist-bullet2" /> Med Target Achieved %</li>
                                    <li><div className="icz-ridatalist-bullet6" /> Low Target Achieved %</li>
                                  </ul>
                                </Col>
                              </div>
                            </>
                            :
                            <Loader />}
                        </div>

                      </div>
                    </div>

                    <div className="grid grid_cols_1">
                      <div className="icz-sectioncardwrapper w-100">
                        <div className="icz-sectioncard">
                          <Col sm={12} className="icz-cardheader flex-wrap">
                            <Col lg={8} md={4} sm={12} className="icz-cardtitle">
                              Customer Segmentation
                            </Col>
                            <Col lg={4} md={8} sm={12} className="icz-cardfilter flex-row flex-wrap ">
                              {/* <Dropdown dropdown_options={this.state.custprofiling_dropdown_options} dropdown_placeholder="Filters" parentCallback={this.handleCallback} /> */}
                              <div className="icz-cardbtnwrapper">
                                <ChartExport ChartId='customer_share_profiling' exportName="Customer Profiling"
                                  export_href={this.state.export_href} downloadName="Customer-Profiling.csv"
                                  export_data={this.state.customerdata}
                                />
                              </div>
                            </Col>
                          </Col>
                          <Col lg={12} className="d-flex" id="customer_share_profiling">
                            <Col sm={12} lg={4} className="icz-cardpadding">
                              <RiSalesPieChart card_id="customer_share" card_class="icz-sectionchart" graph-data={this.state.customerdata} section1_color={"#11a1fd"} section2_color={"#ff9931"} section3_color={"#07c180"} section4_color={"#5a75f9"} />
                            </Col>
                            <Col sm={12} lg={8} className="icz-cardpadding">
                              <StackedColumnChart chart_id="customer_profiling" chart_class="icz-sectionchart" graph-data={this.state.custprofiledata} Xtitle={""} Ytitle={"No. of Customers"} metric_1={"High Net Worth Individuals"} metric_2={"Risk to Churn"} metric_3={"Loyal Customers"} metric_4={"Affluent Customers"} bar1_color={"#5a75f9"} bar2_color={"#07c180"} bar3_color={"#ff9931"} bar4_color={"#11a1fd"} />
                            </Col>
                          </Col>
                          <div>
                            <Col lg={12} className="icz-ridatabullet">
                              <ul className="icz-ridatalist-inline">
                                <li><div className="icz-ridatalist-bullet4" /> Affluent Customers</li>
                                <li><div className="icz-ridatalist-bullet2" /> Loyal Customers</li>
                                <li><div className="icz-ridatalist-bullet3" /> Risk to Churn</li>
                                <li><div className="icz-ridatalist-bullet1" /> High Net Worth Individuals</li>
                              </ul>
                            </Col>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div >
          </div >
        </div >
      </Wrapper >
    );
  }
}

function mapStateToProps(state) {
  return {
    start_date: state.date.startDate,
    end_date: state.date.endDate,
    previous_start_date: state.date.prevStartDate,
    previous_end_date: state.date.prevEndDate,
    country: state.userData.user.country_code,
    globalSelectedBrand: state.globalSelectedBrandIds.selectedBrands && state.globalSelectedBrandIds.selectedBrands[0]
  };
}

export default connect(mapStateToProps)(StoreHealthOverview);